import { Component, OnInit, Output } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from "@angular/material/snack-bar";
import { ActivatedRoute, Router } from "@angular/router";
import { ErrorAlertComponent } from "src/app/shared/components/alert/error-alert/error-alert.component";
import { CepService } from "src/app/shared/services/cep.service";
import { CpfService } from "src/app/shared/services/cpf.service";

import { ColetorService } from "../coletor/coletor.service";
import { CpfModalService } from "../cpf-modal/cpf-modal.service";
import { Doador } from "../doador/doador";
import { DadosFormService } from "../doador/doador.service";
import { DoadorStore } from "../doador/doador.store";
import { PdfContratoCreateComponent } from "../pdf-contrato-create/pdf-contrato-create.component";
import { PdfFichaCreateComponent } from "../pdf-ficha-create/pdf-ficha-create.component";
import { PdfTermoCreateComponent } from "../pdf-termo-create/pdf-termo-create.component";
import { TecidoList } from "../tecidos-captados/tecido";
import {
  ConfirmacaoComponent,
  ConfirmDialogModel,
} from "./confirmacao/confirmacao.component";
import { DadosFormList } from "./dados-form";

@Component({
  selector: "app-dados-form",
  templateUrl: "./dados-form.component.html",
  styleUrls: ["./dados-form.component.css"],
})
export class DadosFormComponent implements OnInit {
  result: string = "";
  load: boolean;
  habilitarBotoes: boolean = true;
  desabilitarBotoes: boolean = true;
  idCaptacao: string;
  idCirurgiao: string;
  dadosCadastraisForm: FormGroup;
  dadosForm: DadosFormList;
  title: string;
  buttonTitle: string;
  buttonCancel: string = "Cancelar";
  buttonFinalizar: string = "Finalizar Coleta";
  buttonEdit: boolean;
  status: string;
  captacao: any;
  tecidoCaptado: FormArray;
  flagEdicao: string;
  flagEdCliente: string;
  flagEdColeta: string;
  editarWeb: boolean = true;
  botoesPDF: boolean = true;
  validacaoTecidos: boolean;
  statusDaColeta: string;
  botaoFinalizarColeta: boolean = false;
  @Output() contratoValido: boolean = false;
  termoValido: boolean = false;
  termoValdoFlag = false;
  fichaValida: boolean = false;
  cpfString: string;
  desabilitarBotoesAoIniciarForm: boolean = false;
  @Output() desabilitarFormResp: boolean = false;
  @Output() maiorDeIdade: boolean = false;
  @Output() captacaoTecidosCaptados: TecidoList[] = [];
  @Output() finalizarCliente: boolean;
  @Output() finalizarEdColeta: boolean;
  horizontalPosition: MatSnackBarHorizontalPosition = "center";
  verticalPosition: MatSnackBarVerticalPosition = "top";
  desablititarBotaoFinalizarColeta = false;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private cepService: CepService,
    private dadosFormService: DadosFormService,
    private _snackBar: MatSnackBar,
    private dialog: MatDialog,
    private router: Router,
    private store: DoadorStore,
    private pdf: MatDialog,
    private cpfService: CpfService,
    private cpfModalService: CpfModalService,
    private coletorService: ColetorService
  ) {
    this.idCaptacao = this.route.snapshot.paramMap.get("idDoador");
    this.idCirurgiao = this.route.snapshot.paramMap.get("idCirurgiao");
    this.captacao = this.route.snapshot.data;
    this.dadosCadastraisForm = this.formBuilder.group({
      editarWeb: [""],
      doador: this.formBuilder.group({
        editarCliente: [""],
        dataHoraEditarCliente: [""],
        taxaContrato: ["", Validators.required],
        situacao: [""],
        tipagemSanguinea: [""],
        nome: ["", Validators.required],
        dataNascimento: ["", Validators.required],
        sexo: ["", Validators.required],
        cpf: ["", Validators.required],
        rg: ["", Validators.required],
        estadoCivil: ["", Validators.required],
        nacionalidade: ["", Validators.required],
        profissao: ["", Validators.required],
        telefone: [""],
        telefoneCelular: ["", Validators.required],
        endereco: ["", Validators.required],
        complemento: [""],
        rh: [""],
        bairro: ["", Validators.required],
        cidade: ["", Validators.required],
        estado: ["", Validators.required],
        cep: ["", Validators.required],
        enderecoComercial: [""],
        complementoComercial: [""],
        bairroComercial: [""],
        cidadeComercial: [""],
        estadoComercial: [""],
        cepComercial: [""],
        numEndereco: ["", Validators.required],
        telefoneComercial: [""],
        email: ["", [Validators.required, Validators.email]],
        emailComercial: [""],
        numeroAlvara: [""],
        municipioAlvara: [""],
        validadeAlvara: [""],
        numeroLicencaSanitaria: [""],
        municipioLicencaSanitaria: [""],
        validadeLicencaSanitaria: [""],
        enderecoComercial2: [""],
        complementoComercial2: [""],
        bairroComercial2: [""],
        cidadeComercial2: [""],
        estadoComercial2: [""],
        cepComercial2: [""],
        telefoneComercial2: [""],
        emailComercial2: [""],
        numeroAlvara2: [""],
        municipioAlvara2: [""],
        validadeAlvara2: [""],
        numeroLicencaSanitaria2: [""],
        municipioLicencaSanitaria2: [""],
        validadeLicencaSanitaria2: [""],
        observacoes: [""],
      }),

      captacao: this.formBuilder.group({
        editarColeta: [""],
        destinoTecidosDuros: ["", Validators.required],
        destinoMaterialBiologico: ["", Validators.required],
        doacaoPesquisa: [""],
        nomeResponsavel1: ["", Validators.required],
        dataNascimentoResponsavel1: ["", Validators.required],
        cpfResponsavel1: ["", Validators.required],
        rgResponsavel1: ["", Validators.required],
        emailResponsavel1: ["", [Validators.required, Validators.email]],
        telefoneResponsavel1: [""],
        telefoneCelularResponsavel1: ["", Validators.required],
        cepResponsavel1: ["", Validators.required],
        enderecoResponsavel1: ["", Validators.required],
        complementoResponsavel1: [""],
        bairroResponsavel1: ["", Validators.required],
        cidadeResponsavel1: ["", Validators.required],
        estadoResponsavel1: ["", Validators.required],
        numEnderecoResponsavel1: ["", Validators.required],
        estadoCivilResp1: ["", Validators.required],
        nacionalidadeResp1: ["", Validators.required],
        profissaoResp1: ["", Validators.required],
        grauParentescoResp1: ["", Validators.required],
        nomeResponsavel2: [""],
        dataNascimentoResponsavel2: [""],
        cpfResponsavel2: [""],
        rgResponsavel2: [""],
        emailResponsavel2: [""],
        telefoneResponsavel2: [""],
        telefoneCelularResponsavel2: [""],
        cepResponsavel2: [""],
        enderecoResponsavel2: [""],
        complementoResponsavel2: [""],
        bairroResponsavel2: [""],
        cidadeResponsavel2: [""],
        estadoResponsavel2: [""],
        numEnderecoResponsavel2: [""],
        estadoCivilResp2: [""],
        nacionalidadeResp2: [""],
        profissaoResp2: [""],
        grauParentescoResp2: [""],
        dataExamesSanguineos: ["", Validators.required],
        paiFlag: ["", Validators.required],
        descPai: [""],
        hemograma: ["", Validators.required],
        localCaptacao: ["", Validators.required],
        descricaoLocalColeta: [""],
        historiaMedicaSocial1Flag: ["", Validators.required],
        historiaMedicaSocial2Flag: ["", Validators.required],
        historiaMedicaSocial3Flag: ["", Validators.required],
        historiaMedicaSocial4Flag: ["", Validators.required],
        historiaMedicaSocial5Flag: ["", Validators.required],
        historiaMedicaSocial6Flag: ["", Validators.required],
        historiaMedicaSocial7Flag: ["", Validators.required],
        historiaMedicaSocial8Flag: ["", Validators.required],
        historiaMedicaSocial9Flag: ["", Validators.required],
        historiaMedicaSocial10Flag: ["", Validators.required],
        historiaMedicaSocial11Flag: ["", Validators.required],
        historiaMedicaSocial12Flag: ["", Validators.required],
        historiaMedicaSocial13Flag: ["", Validators.required],
        historiaMedicaSocial1: [""],
        historiaMedicaSocial2: [""],
        historiaMedicaSocial3: [""],
        historiaMedicaSocial4: [""],
        historiaMedicaSocial5: [""],
        historiaMedicaSocial6: [""],
        historiaMedicaSocial7: [""],
        historiaMedicaSocial8: [""],
        historiaMedicaSocial9: [""],
        historiaMedicaSocial10: [""],
        historiaMedicaSocial11: [""],
        historiaMedicaSocial12: [""],
        historiaMedicaSocial13: [""],
        anemia: [""],
        dengue: [""],
        doencaNoFigado: [""],
        hemorragias: [""],
        hemofilia: [""],
        leucemia: [""],
        chikungunya: [""],
        febreReumatica: [""],
        hepatiteA: [""],
        hepatiteB: [""],
        hepatiteC: [""],
        hepatite_a: [""],
        hepatite_b: [""],
        hepatite_c: [""],
        febre_sem_diagnostico: [""],
        tuberculose: [""],
        zika: [""],
        diabetes: [""],
        doencaNosRins: [""],
        febre: [""],
        covid: [""],
        exameFisico1Flag: ["", Validators.required],
        exameFisico2Flag: ["", Validators.required],
        exameFisico3Flag: ["", Validators.required],
        exameFisico4Flag: ["", Validators.required],
        exameFisico5Flag: ["", Validators.required],
        exameFisico1: [""],
        exameFisico2: [""],
        exameFisico3: [""],
        exameFisico4: [""],
        exameFisico5: [""],
        desc_transoperatorio: [""],
        clivagem: ["", Validators.required],
        profilaxia: ["", Validators.required],
        proc_anestesico: [""],
        trypanosoma_1: ["", Validators.required],
        trypanosoma_2: ["", Validators.required],
        citomegalovirus_1: ["", Validators.required],
        citomegalovirus_2: ["", Validators.required],
        hiv_1: ["", Validators.required],
        hiv_2: ["", Validators.required],
        htlv: ["", Validators.required],
        hepatiteB_1: ["", Validators.required],
        hepatiteB_2: ["", Validators.required],
        hepatiteB_3: ["", Validators.required],
        hepatiteB_4: ["", Validators.required],
        hepatiteC_1: ["", Validators.required],
        treponemaPallidum_1: ["", Validators.required],
        treponemaPallidum_2: ["", Validators.required],
        sifilisvdrl: ["", Validators.required],
        toxoplasmaGondii_1: ["", Validators.required],
        toxoplasmaGondii_2: ["", Validators.required],
        malaria_1: ["", Validators.required],
        malaria_2: ["", Validators.required],
        sorologia: [""],
        observacoesHistoricoSaude: [""],
        observacoesExameFisico: [""],
        observacoesColeta: [""],
        observacoesDadosLaboratoriais: [""],
        transportadora: ["", Validators.required],
        dataColeta: ["", Validators.required],
        inicioProcedimento: ["", Validators.required],
        fimProcedimento: ["", Validators.required],
        dataRecebimentoCPC: [""],
        horarioRecebimentoCPC: [""],
        bochechos: ["", Validators.required],
        anestesicoTopico: ["", Validators.required],
        anestesicoInjetavel: ["", Validators.required],
        anestesicoVasoConstritor: ["", Validators.required],
        odontoseccao: ["", Validators.required],
        remocaoRestauracoes: ["", Validators.required],
        remocaoCaries: ["", Validators.required],
        desc_Bochechos: [""],
        desc_AnestesicoTopico: [""],
        desc_AnestesicoInjetavel: [""],
        desc_AnestesicoConstritor: [""],
        desc_FendaClivagem: [""],
        desc_Odontoseccao: [""],
        desc_RemocaoRestauracoes: [""],
        desc_RemocaoCaries: [""],
        sARS_CoV2_Covid_19_igg: ["", Validators.required],
        sARS_CoV2_Covid_19_igm: ["", Validators.required],
        sARS_CoV2_Covid_pcr: ["", Validators.required],

        pcrqualitativocmv: ["", Validators.required],
        pcrquantitativohepatiteb: ["", Validators.required],
        pcrqualitativohepatitec: ["", Validators.required],
        pcrqualitativohiv: ["", Validators.required],
        pcrhtlv1: ["", Validators.required],
        pcrhtlv2: ["", Validators.required],
        pcrqualitativoepsteinbarr: ["", Validators.required],
        examesadicionais: ["", Validators.required],

        dataHoraEditarColeta: [""],

        outroProfilaxia: [""],
        outroBochechos: [""],
        outroAnestesicoTopico: [""],
        outroAnestesicoInjetavel: [""],
        outroAnestesicoConstritor: [""],
        clorexidinaPorcentagem: [""],
        perboratoSodioPorcentagem: [""],
        cetilperidinioPorcentagem: [""],
        outroBochechoPorcentagem: [""],
        benzbcainaPorcentagem: [""],
        tetracainaPorcentagem: [""],
        xilocainaPorcentagem: [""],
        outroAnestesicoTPorcentagem: [""],
        benzocainaPorcentagem: [""],
        mepivacainaPorcentagem: [""],
        prilocainaPorcentagem: [""],
        citocainaPorcentagem: [""],
        lidocainaPorcentagem: [""],
        outroAnestesicoIPorcentagem: [""],
        articainaPorcentagem: [""],
        adrenalinaPorcentagem: [""],
        noradrenalinaPorcentagem: [""],
        cloridratoFenilefrinaPorcentagem: [""],
        outroAnestesicoCPorcentagem: [""],
        peroxidoHidrogenioPorcentagem: [""],

        outrosAnestesicoVasoConstritor: [""],
        porcentagemOutrosAnestesicoVasoConstritor: [""],
        outrosAnestesicoVasoConstritorDesc: [""],

        pedraPomes: [""],
        pastaPolifatica: [""],
        outroProfilaxiaCheck: [""],
        vestibuloLingual: [""],
        mesioDistal: [""],
        amelocemataria: [""],
        clorexidina: [""],
        perboratoDeSodioBlueM: [""],
        peroxidoDeHidrogenio: [""],
        cetilperidinio: [""],
        outrosBochechoCheck: [""],

        benzocaina: [""],
        tetracaina: [""],
        xilocaina: [""],
        outrosAnestesicoTopicoCheck: [""],

        mepivacaina: [""],
        prilocaina: [""],
        articaina: [""],
        citocaina: [""],
        lidocaina: [""],
        outrosAnestesicoInjetavelCheck: [""],

        adrenalina: [""],
        noradrenalina: [""],
        cloridratoDeFenilefrina: [""],

        hepatite: [""],
        outraDoencaSintoma: [""],
        outraDoencaSintomaCheck: [""],

        naoDoencaSintomaCheck: [""],
      }),

      tecidoCaptado: this.formBuilder.group({
        tecidos: this.formBuilder.array([]),
      }),
    });

    if (this.idCaptacao) {
      this.title = "Coleta";
      this.buttonTitle = "Salvar";
      this.status = "Editando...";
      this.buttonEdit = true;

      this.formatacoesDatasNascimentos();
      this.popularForm();
    } else {
      this.title = "Coleta";
      this.buttonTitle = "Salvar";
      this.status = "Salvando...";
      this.buttonEdit = false;
    }
  }

  onInit() {
    this.idadeDoadorCadastrado();
  }

  formatacoesDatasNascimentos() {
    if (this.captacao.doador.doador.dataNascimento != null) {
      let formatado = this.captacao.doador.doador.dataNascimento
        .replace(/-/, "/")
        .replace(/-/, "/");
      let dataFormatada = formatado.split("/");
      let dataNascimentoString = `${dataFormatada[2]}/${dataFormatada[1]}/${dataFormatada[0]}`;
      this.dadosCadastraisForm.get("doador").patchValue({
        dataNascimento: dataNascimentoString,
      });
    }

    if (this.captacao.doador.coletor.dataNascimentoResponsavel1 != null) {
      let formatado = this.captacao.doador.coletor.dataNascimentoResponsavel1
        .replace(/-/, "/")
        .replace(/-/, "/");
      let dataFormatada = formatado.split("/");
      let dataNascimentoString = `${dataFormatada[0]}/${dataFormatada[1]}/${dataFormatada[2]}`;
      this.dadosCadastraisForm.get("captacao").patchValue({
        dataNascimentoResponsavel1: dataNascimentoString,
      });
    }

    if (this.captacao.doador.coletor.dataNascimentoResponsavel2 != null) {
      let formatado = this.captacao.doador.coletor.dataNascimentoResponsavel2
        .replace(/-/, "/")
        .replace(/-/, "/");
      let dataFormatada = formatado.split("/");
      let dataNascimentoString = `${dataFormatada[0]}/${dataFormatada[1]}/${dataFormatada[2]}`;
      this.dadosCadastraisForm.get("captacao").patchValue({
        dataNascimentoResponsavel2: dataNascimentoString,
      });
    }

    if (this.captacao.doador.coletor.dataExamesSanguineos != null) {
      let formatado = this.captacao.doador.coletor.dataExamesSanguineos
        .replace(/-/, "/")
        .replace(/-/, "/");
      let dataFormatada = formatado.split("/");
      let dataExamesString = `${dataFormatada[2]}/${dataFormatada[1]}/${dataFormatada[0]}`;
      this.dadosCadastraisForm.get("captacao").patchValue({
        dataExamesSanguineos: dataExamesString,
      });
    }

    if (this.captacao.doador.coletor.dataColeta != null) {
      let formatado = this.captacao.doador.coletor.dataColeta
        .replace(/-/, "/")
        .replace(/-/, "/");
      let dataFormatada = formatado.split("/");
      let dataColetaString = `${dataFormatada[2]}/${dataFormatada[1]}/${dataFormatada[0]}`;
      this.dadosCadastraisForm.get("captacao").patchValue({
        dataColeta: dataColetaString,
      });
    }
  }

  inputCPFDesabilitado() {
    this.dadosCadastraisForm.get("doador.cpf").disable();
  }

  consultaCPF() {
    if (this.captacao.doador) return;

    this.cpfModalService.cpfString$.subscribe((cpf) => {
      this.cpfString = cpf;
    });
    this.dadosCadastraisForm.get("doador").patchValue({ cpf: this.cpfString });
  }

  consultaCep() {
    let cep = this.dadosCadastraisForm.get("doador.cep").value;
    this.cepService.buscaCep(cep).subscribe((cep: any) => {
      if (cep == "" || cep.logradouro === undefined) {
        this.dadosCadastraisForm.get("doador.cep").setErrors({ invalid: true });
      }

      this.dadosCadastraisForm.get("doador").patchValue({
        endereco: cep.logradouro,
        cidade: cep.localidade,
        bairro: cep.bairro,
        estado: cep.uf,
      });
    });
  }

  consultaCepResponsavel1() {
    let cep = this.dadosCadastraisForm.get("captacao.cepResponsavel1").value;
    this.cepService.buscaCep(cep).subscribe((cep: any) => {
      if (cep == "" || cep.logradouro === undefined) {
        this.dadosCadastraisForm
          .get("captacao.cepResponsavel1")
          .setErrors({ invalid: true });
      }

      this.dadosCadastraisForm.get("captacao").patchValue({
        enderecoResponsavel1: cep.logradouro,
        cidadeResponsavel1: cep.localidade,
        bairroResponsavel1: cep.bairro,
        estadoResponsavel1: cep.uf,
      });
    });
  }

  consultaCepResponsavel2() {
    let cep = this.dadosCadastraisForm.get("captacao.cepResponsavel2").value;
    this.cepService.buscaCep(cep).subscribe((cep: any) => {
      if (cep == "" || cep.logradouro === undefined) {
        this.dadosCadastraisForm
          .get("captacao.cepResponsavel2")
          .setErrors({ invalid: true });
      }

      this.dadosCadastraisForm.get("captacao").patchValue({
        enderecoResponsavel2: cep.logradouro,
        cidadeResponsavel2: cep.localidade,
        bairroResponsavel2: cep.bairro,
        estadoResponsavel2: cep.uf,
      });
    });
  }

  onCPF() {
    this.consultaCPF();
  }
  onCallParent() {
    this.consultaCep();
  }

  onCallParentResp1() {
    this.consultaCepResponsavel1();
  }

  onCallParentResp2() {
    this.consultaCepResponsavel2();
  }

  submit() {
    if (this.horarioProcedimentoInicioMaior()) return;

    if (!this.maiorDeIdade) {
      if (!this.verificacaoIdadeResp() || !this.idadeResponsaveisCadastro()) {
        return;
      }
    }

    this.dadosCadastraisForm.get("captacao").patchValue({
      //TODO no momento está deixando os valores checados assim que carrega a pagina, verificar
      dengue:
        this.dadosCadastraisForm.get("captacao.dengue").value == true ||
        this.dadosCadastraisForm.get("captacao.dengue").value == "Dengue"
          ? "Dengue"
          : "",
      anemia:
        this.dadosCadastraisForm.get("captacao.anemia").value == true ||
        this.dadosCadastraisForm.get("captacao.anemia").value == "Anemia"
          ? "Anemia"
          : "",
      doencaNoFigado:
        this.dadosCadastraisForm.get("captacao.doencaNoFigado").value == true ||
        this.dadosCadastraisForm.get("captacao.doencaNoFigado").value ==
          "Doença no fígado"
          ? "Doença no fígado"
          : "",
      hemorragias:
        this.dadosCadastraisForm.get("captacao.hemorragias").value == true ||
        this.dadosCadastraisForm.get("captacao.hemorragias").value ==
          "Hemorragias"
          ? "Hemorragias"
          : "",
      hemofilia:
        this.dadosCadastraisForm.get("captacao.hemofilia").value == true ||
        this.dadosCadastraisForm.get("captacao.hemofilia").value == "Hemofilia"
          ? "Hemofilia"
          : "",
      leucemia:
        this.dadosCadastraisForm.get("captacao.leucemia").value == true ||
        this.dadosCadastraisForm.get("captacao.leucemia").value == "Leucemia"
          ? "Leucemia"
          : "",
      chikungunya:
        this.dadosCadastraisForm.get("captacao.chikungunya").value == true ||
        this.dadosCadastraisForm.get("captacao.chikungunya").value ==
          "Chikungunya"
          ? "Chikungunya"
          : "",
      febreReumatica:
        this.dadosCadastraisForm.get("captacao.febreReumatica").value == true ||
        this.dadosCadastraisForm.get("captacao.febreReumatica").value ==
          "Febre Reumática"
          ? "Febre Reumática"
          : "",
      covid:
        this.dadosCadastraisForm.get("captacao.covid").value == true ||
        this.dadosCadastraisForm.get("captacao.covid").value == "Covid-19"
          ? "Covid-19"
          : "",
      hepatite:
        this.dadosCadastraisForm.get("captacao.hepatite").value == true ||
        this.dadosCadastraisForm.get("captacao.hepatite").value == "Hepatite"
          ? "Hepatite"
          : "",
      tuberculose:
        this.dadosCadastraisForm.get("captacao.tuberculose").value == true ||
        this.dadosCadastraisForm.get("captacao.tuberculose").value ==
          "Tuberculose"
          ? "Tuberculose"
          : "",
      zika:
        this.dadosCadastraisForm.get("captacao.zika").value == true ||
        this.dadosCadastraisForm.get("captacao.zika").value == "Zika"
          ? "Zika"
          : "",
      diabetes:
        this.dadosCadastraisForm.get("captacao.diabetes").value == true ||
        this.dadosCadastraisForm.get("captacao.diabetes").value == "Diabetes"
          ? "Diabetes"
          : "",
      doencaNosRins:
        this.dadosCadastraisForm.get("captacao.doencaNosRins").value == true ||
        this.dadosCadastraisForm.get("captacao.doencaNosRins").value ==
          "Doença nos rins"
          ? "Doença nos rins"
          : "",
      hepatite_a:
        this.dadosCadastraisForm.get("captacao.hepatite_a").value == true ||
        this.dadosCadastraisForm.get("captacao.hepatite_a").value ==
          "Hepatite A"
          ? "Hepatite A"
          : "",
      hepatite_b:
        this.dadosCadastraisForm.get("captacao.hepatite_b").value == true ||
        this.dadosCadastraisForm.get("captacao.hepatite_b").value ==
          "Hepatite B"
          ? "Hepatite B"
          : "",
      hepatite_c:
        this.dadosCadastraisForm.get("captacao.hepatite_c").value == true ||
        this.dadosCadastraisForm.get("captacao.hepatite_c").value ==
          "Hepatite C"
          ? "Hepatite C"
          : "",
      febre_sem_diagnostico:
        this.dadosCadastraisForm.get("captacao.febre_sem_diagnostico").value ==
          true ||
        this.dadosCadastraisForm.get("captacao.febre_sem_diagnostico").value ==
          "Febre sem diagnóstico"
          ? "Febre sem diagnóstico"
          : "",
      febre:
        this.dadosCadastraisForm.get("captacao.febre").value == true
          ? "Febre sem diagnóstico"
          : "",

      pedraPomes:
        this.dadosCadastraisForm.get("captacao.pedraPomes").value == true ||
        this.dadosCadastraisForm.get("captacao.pedraPomes").value ==
          "Pedra Pomes"
          ? "Pedra Pomes"
          : "",
      pastaPolifatica:
        this.dadosCadastraisForm.get("captacao.pastaPolifatica").value ==
          true ||
        this.dadosCadastraisForm.get("captacao.pastaPolifatica").value ==
          "pasta profilática"
          ? "pasta profilática"
          : "",
      outroProfilaxiaCheck:
        this.dadosCadastraisForm.get("captacao.outroProfilaxiaCheck").value ==
          true ||
        this.dadosCadastraisForm.get("captacao.outroProfilaxiaCheck").value ==
          "Outro"
          ? "Outro"
          : "",
      vestibuloLingual:
        this.dadosCadastraisForm.get("captacao.vestibuloLingual").value ==
          true ||
        this.dadosCadastraisForm.get("captacao.vestibuloLingual").value ==
          "Vestíbulo-lingual"
          ? "Vestíbulo-lingual"
          : "",
      mesioDistal:
        this.dadosCadastraisForm.get("captacao.mesioDistal").value == true ||
        this.dadosCadastraisForm.get("captacao.mesioDistal").value ==
          "Mesio-distal"
          ? "Mesio-distal"
          : "",
      amelocemataria:
        this.dadosCadastraisForm.get("captacao.amelocemataria").value == true ||
        this.dadosCadastraisForm.get("captacao.amelocemataria").value ==
          "Amelocementária"
          ? "Amelocementária"
          : "",

      clorexidina:
        this.dadosCadastraisForm.get("captacao.clorexidina").value == true ||
        this.dadosCadastraisForm.get("captacao.clorexidina").value ==
          "Clorexidina"
          ? "Clorexidina"
          : "",
      perboratoDeSodioBlueM:
        this.dadosCadastraisForm.get("captacao.perboratoDeSodioBlueM").value ==
          true ||
        this.dadosCadastraisForm.get("captacao.perboratoDeSodioBlueM").value ==
          "Perborato de Sódio (BlueM)"
          ? "Perborato de Sódio (BlueM)"
          : "",
      peroxidoDeHidrogenio:
        this.dadosCadastraisForm.get("captacao.peroxidoDeHidrogenio").value ==
          true ||
        this.dadosCadastraisForm.get("captacao.peroxidoDeHidrogenio").value ==
          "Peróxido de hidrogênio"
          ? "Peróxido de hidrogênio"
          : "",
      cetilperidinio:
        this.dadosCadastraisForm.get("captacao.cetilperidinio").value == true ||
        this.dadosCadastraisForm.get("captacao.cetilperidinio").value ==
          "Cetilperidínio"
          ? "Cetilperidínio"
          : "",
      outrosBochechoCheck:
        this.dadosCadastraisForm.get("captacao.outrosBochechoCheck").value ==
          true ||
        this.dadosCadastraisForm.get("captacao.outrosBochechoCheck").value ==
          "Outros"
          ? "Outros"
          : "",

      benzocaina:
        this.dadosCadastraisForm.get("captacao.benzocaina").value == true ||
        this.dadosCadastraisForm.get("captacao.benzocaina").value ==
          "Benzocaína"
          ? "Benzocaína"
          : "",
      tetracaina:
        this.dadosCadastraisForm.get("captacao.tetracaina").value == true ||
        this.dadosCadastraisForm.get("captacao.tetracaina").value ==
          "Tetracaína"
          ? "Tetracaína"
          : "",
      xilocaina:
        this.dadosCadastraisForm.get("captacao.xilocaina").value == true ||
        this.dadosCadastraisForm.get("captacao.xilocaina").value == "Xilocaína"
          ? "Xilocaína"
          : "",
      outrosAnestesicoTopicoCheck:
        this.dadosCadastraisForm.get("captacao.outrosAnestesicoTopicoCheck")
          .value == true ||
        this.dadosCadastraisForm.get("captacao.outrosAnestesicoTopicoCheck")
          .value == "Outros"
          ? "Outros"
          : "",

      mepivacaina:
        this.dadosCadastraisForm.get("captacao.mepivacaina").value == true ||
        this.dadosCadastraisForm.get("captacao.mepivacaina").value ==
          "Mepivacaína"
          ? "Mepivacaína"
          : "",
      prilocaina:
        this.dadosCadastraisForm.get("captacao.prilocaina").value == true ||
        this.dadosCadastraisForm.get("captacao.prilocaina").value ==
          "Prilocaína"
          ? "Prilocaína"
          : "",
      articaina:
        this.dadosCadastraisForm.get("captacao.articaina").value == true ||
        this.dadosCadastraisForm.get("captacao.articaina").value == "Articaína"
          ? "Articaína"
          : "",
      citocaina:
        this.dadosCadastraisForm.get("captacao.citocaina").value == true ||
        this.dadosCadastraisForm.get("captacao.citocaina").value == "Citocaína"
          ? "Citocaína"
          : "",
      lidocaina:
        this.dadosCadastraisForm.get("captacao.lidocaina").value == true ||
        this.dadosCadastraisForm.get("captacao.lidocaina").value == "Lidocaína"
          ? "Lidocaína"
          : "",
      outrosAnestesicoInjetavelCheck:
        this.dadosCadastraisForm.get("captacao.outrosAnestesicoInjetavelCheck")
          .value == true ||
        this.dadosCadastraisForm.get("captacao.outrosAnestesicoInjetavelCheck")
          .value == "Outros"
          ? "Outros"
          : "",

      adrenalina:
        this.dadosCadastraisForm.get("captacao.adrenalina").value == true ||
        this.dadosCadastraisForm.get("captacao.adrenalina").value ==
          "Adrenalina"
          ? "Adrenalina"
          : "",
      noradrenalina:
        this.dadosCadastraisForm.get("captacao.noradrenalina").value == true ||
        this.dadosCadastraisForm.get("captacao.noradrenalina").value ==
          "Noradrenalina"
          ? "Noradrenalina"
          : "",
      cloridratoDeFenilefrina:
        this.dadosCadastraisForm.get("captacao.cloridratoDeFenilefrina")
          .value == true ||
        this.dadosCadastraisForm.get("captacao.cloridratoDeFenilefrina")
          .value == "Cloridrato de fenilefrina"
          ? "Cloridrato de fenilefrina"
          : "",

      outraDoencaSintomaCheck:
        this.dadosCadastraisForm.get("captacao.outraDoencaSintomaCheck")
          .value == true ||
        this.dadosCadastraisForm.get("captacao.outraDoencaSintomaCheck")
          .value == "Outra"
          ? "Outra"
          : "",

      outrosAnestesicoVasoConstritor:
        this.dadosCadastraisForm.get("captacao.outrosAnestesicoVasoConstritor")
          .value == true ||
        this.dadosCadastraisForm.get("captacao.outrosAnestesicoVasoConstritor")
          .value == "Outros"
          ? "Outros"
          : "",
      naoDoencaSintomaCheck:
        this.dadosCadastraisForm.get("captacao.naoDoencaSintomaCheck").value ==
          true ||
        this.dadosCadastraisForm.get("captacao.naoDoencaSintomaCheck").value ==
          "Não"
          ? "Não"
          : "",

      editarColeta: this.flagEdColeta,
      editarCliente: this.flagEdCliente,
    });

    let tecidos = this.dadosCadastraisForm
      .get("tecidoCaptado")
      .get("tecidos") as FormArray;
    tecidos.clear();

    this.captacaoTecidosCaptados.map((res) => {
      tecidos.push(
        this.formBuilder.group({
          codigo: res.codigo,
          nome: res.nome,
          codigoCaptacao: res.codigoCaptacao,
          acao: res.acao == null ? "" : res.acao,
        })
      );
    });
    let json = JSON.stringify(this.dadosCadastraisForm.getRawValue());
    this.load = true;

    if (this.idCaptacao) {
      this.updateForm(this.idCaptacao, json);
      return;
    }

    this.saveForm(json);
  }

  saveForm(json) {
    const observer = {
      next: (x) => this.saveFormOnSuccess(x),
      error: (err) => this.saveFormOnError(err),
      complete: () => this.saveFormOnComplete(),
    };
    this.dadosFormService.save(json).subscribe(observer);
  }

  saveFormOnSuccess(res) {
    this.openSnackBar("Coleta alterada com sucesso!", "Fechar");
    this.store.addDoador(res.doador);
    let id = res.coletor.codigo;
    this.router.navigate(["captacao/" + id]);
  }

  saveFormOnError(err) {
    const dialogRef = this.dialog.open(ErrorAlertComponent, {
      width: "350px",
      data: { name: "Erro ao cadastrar a coleta. Tente novamente!" },
    });
  }

  saveFormOnComplete() {
    this.load = false;
  }

  updateForm(idCaptacao, json) {
    const observer = {
      next: (x) => this.updateFormOnSuccess(x),
      error: (err) => this.updateFormOnError(err),
      complete: () => this.updateFormOnComplete(),
    };
    this.dadosFormService.update(this.idCaptacao, json).subscribe(observer);
  }

  updateFormOnSuccess(res) {
    if (res.tecidos.tecidoCaptado[0].codigo) {
      this.validacaoTecidos = true;
    } else {
      this.validacaoTecidos = false;
    }
    this.idadeDoadoUpdate(res.doador);
    this.desabilatarBotoesAoSalvar();
    // this.store.updateDoador(res);
    this.captacaoTecidosCaptados = res.tecidos.tecidoCaptado;
    // this.resetarTecidosCaptadosAoSalvar();
    this.validacaoColetaBotao();
    this.validacaoContratovalido();
    this.openSnackBar("Coleta alterada com sucesso!", "Fechar");
    this.captacao.doador.doador = res.doador;
    this.captacao.doador.coletor = res.coletor;
  }

  updateFormOnError(err) {
    const dialogRef = this.dialog.open(ErrorAlertComponent, {
      width: "350px",
      data: { name: "Erro ao alterar a coleta. Tente novamente!" },
    });
  }

  updateFormOnComplete() {
    this.load = false;
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 3000,
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
    });
  }

  popularForm() {
    this.dadosCadastraisForm.get("doador").patchValue({
      nome: this.captacao.doador.doador.nome,
      cpf: this.captacao.doador.doador.cpf,
      rg: this.captacao.doador.doador.rg,
      estadoCivil: this.captacao.doador.doador.estadoCivil,
      nacionalidade: this.captacao.doador.doador.nacionalidade,
      sexo: this.captacao.doador.doador.sexo,
      estado: this.captacao.doador.doador.estado,
      profissao: this.captacao.doador.doador.profissao,
      rh: this.captacao.doador.doador.rh,
      tipagemSanguinea: this.captacao.doador.doador.tipagemSanguinea,
      email: this.captacao.doador.doador.email,
      cep: this.captacao.doador.doador.cep,
      endereco: this.captacao.doador.doador.endereco,
      bairro: this.captacao.doador.doador.bairro,
      cidade: this.captacao.doador.doador.cidade,
      numEndereco: this.captacao.doador.doador.numEndereco,
      complemento: this.captacao.doador.doador.complemento,
      telefone: this.captacao.doador.doador.telefone,
      telefoneCelular: this.captacao.doador.doador.telefoneCelular,
      telefoneComercial: this.captacao.doador.doador.telefoneComercial,
      observacoes: this.captacao.doador.doador.observacoes,
      taxaContrato: this.captacao.doador.doador.taxaContrato,
    });
    this.dadosCadastraisForm.get("captacao").patchValue({
      destinoTecidosDuros: this.captacao.doador.coletor.destinoTecidosDuros,
      destinoMaterialBiologico:
        this.captacao.doador.coletor.destinoMaterialBiologico,
      // doacaoPesquisa: this.captacao.doador.coletor.doacaoPesquisa,
      nomeResponsavel1: this.captacao.doador.coletor.nomeResponsavel1,
      grauDeParentescoResponsavel1:
        this.captacao.doador.coletor.grauDeParentescoResponsavel1,
      cpfResponsavel1: this.captacao.doador.coletor.cpfResponsavel1,
      rgResponsavel1: this.captacao.doador.coletor.rgResponsavel1,
      emailResponsavel1: this.captacao.doador.coletor.emailResponsavel1,
      telefoneResponsavel1: this.captacao.doador.coletor.telefoneResponsavel1,
      telefoneCelularResponsavel1:
        this.captacao.doador.coletor.telefoneCelularResponsavel1,
      cepResponsavel1: this.captacao.doador.coletor.cepResponsavel1,
      enderecoResponsavel1: this.captacao.doador.coletor.enderecoResponsavel1,
      complementoResponsavel1:
        this.captacao.doador.coletor.complementoResponsavel1,
      bairroResponsavel1: this.captacao.doador.coletor.bairroResponsavel1,
      cidadeResponsavel1: this.captacao.doador.coletor.cidadeResponsavel1,
      estadoResponsavel1: this.captacao.doador.coletor.estadoResponsavel1,
      numEnderecoResponsavel1:
        this.captacao.doador.coletor.numEnderecoResponsavel1,
      estadoCivilResp1: this.captacao.doador.coletor.estadoCivilResp1,
      nacionalidadeResp1: this.captacao.doador.coletor.nacionalidadeResp1,
      profissaoResp1: this.captacao.doador.coletor.profissaoResp1,
      grauParentescoResp1: this.captacao.doador.coletor.grauParentescoResp1,

      nomeResponsavel2: this.captacao.doador.coletor.nomeResponsavel2,
      grauDeParentescoResponsavel2:
        this.captacao.doador.coletor.grauDeParentescoResponsavel2,
      cpfResponsavel2: this.captacao.doador.coletor.cpfResponsavel2,
      rgResponsavel2: this.captacao.doador.coletor.rgResponsavel2,
      emailResponsavel2: this.captacao.doador.coletor.emailResponsavel2,
      telefoneResponsavel2: this.captacao.doador.coletor.telefoneResponsavel2,
      telefoneCelularResponsavel2:
        this.captacao.doador.coletor.telefoneCelularResponsavel2,
      cepResponsavel2: this.captacao.doador.coletor.cepResponsavel2,
      enderecoResponsavel2: this.captacao.doador.coletor.enderecoResponsavel2,
      complementoResponsavel2:
        this.captacao.doador.coletor.complementoResponsavel2,
      bairroResponsavel2: this.captacao.doador.coletor.bairroResponsavel2,
      cidadeResponsavel2: this.captacao.doador.coletor.cidadeResponsavel2,
      estadoResponsavel2: this.captacao.doador.coletor.estadoResponsavel2,
      numEnderecoResponsavel2:
        this.captacao.doador.coletor.numEnderecoResponsavel2,
      estadoCivilResp2: this.captacao.doador.coletor.estadoCivilResp2,
      nacionalidadeResp2: this.captacao.doador.coletor.nacionalidadeResp2,
      profissaoResp2: this.captacao.doador.coletor.profissaoResp2,
      grauParentescoResp2: this.captacao.doador.coletor.grauParentescoResp2,

      //dataExamesSanguineos: this.captacao.doador.coletor.dataExamesSanguineos,
      paiFlag: this.captacao.doador.coletor.paiFlag,
      descPai: this.captacao.doador.coletor.descPai,
      hemograma: this.captacao.doador.coletor.hemograma,
      localCaptacao: this.captacao.doador.coletor.localCaptacao,
      descricaoLocalColeta: this.captacao.doador.coletor.descricaoLocalColeta,
      historiaMedicaSocial1Flag:
        this.captacao.doador.coletor.historiaMedicaSocial1Flag,
      historiaMedicaSocial2Flag:
        this.captacao.doador.coletor.historiaMedicaSocial2Flag,
      historiaMedicaSocial3Flag:
        this.captacao.doador.coletor.historiaMedicaSocial3Flag,
      historiaMedicaSocial4Flag:
        this.captacao.doador.coletor.historiaMedicaSocial4Flag,
      historiaMedicaSocial5Flag:
        this.captacao.doador.coletor.historiaMedicaSocial5Flag,
      historiaMedicaSocial6Flag:
        this.captacao.doador.coletor.historiaMedicaSocial6Flag,
      historiaMedicaSocial7Flag:
        this.captacao.doador.coletor.historiaMedicaSocial7Flag,
      historiaMedicaSocial8Flag:
        this.captacao.doador.coletor.historiaMedicaSocial8Flag,
      historiaMedicaSocial9Flag:
        this.captacao.doador.coletor.historiaMedicaSocial9Flag,
      historiaMedicaSocial10Flag:
        this.captacao.doador.coletor.historiaMedicaSocial10Flag,
      historiaMedicaSocial11Flag:
        this.captacao.doador.coletor.historiaMedicaSocial11Flag,
      historiaMedicaSocial12Flag:
        this.captacao.doador.coletor.historiaMedicaSocial12Flag,
      historiaMedicaSocial13Flag:
        this.captacao.doador.coletor.historiaMedicaSocial13Flag,
      historiaMedicaSocial1: this.captacao.doador.coletor.historiaMedicaSocial1,
      historiaMedicaSocial2: this.captacao.doador.coletor.historiaMedicaSocial2,
      historiaMedicaSocial3: this.captacao.doador.coletor.historiaMedicaSocial3,
      historiaMedicaSocial4: this.captacao.doador.coletor.historiaMedicaSocial4,
      historiaMedicaSocial5: this.captacao.doador.coletor.historiaMedicaSocial5,
      historiaMedicaSocial6: this.captacao.doador.coletor.historiaMedicaSocial6,
      historiaMedicaSocial7: this.captacao.doador.coletor.historiaMedicaSocial7,
      historiaMedicaSocial8: this.captacao.doador.coletor.historiaMedicaSocial8,
      historiaMedicaSocial9: this.captacao.doador.coletor.historiaMedicaSocial9,
      historiaMedicaSocial10:
        this.captacao.doador.coletor.historiaMedicaSocial10,
      historiaMedicaSocial11:
        this.captacao.doador.coletor.historiaMedicaSocial11,
      historiaMedicaSocial12:
        this.captacao.doador.coletor.historiaMedicaSocial12,
      historiaMedicaSocial13:
        this.captacao.doador.coletor.historiaMedicaSocial13,
      anemia: this.captacao.doador.coletor.anemia,

      hepatite_a: this.captacao.doador.coletor.hepatite_a,
      hepatite_b: this.captacao.doador.coletor.hepatite_b,
      hepatite_c: this.captacao.doador.coletor.hepatite_c,
      febre_sem_diagnostico: this.captacao.doador.coletor.febre_sem_diagnostico,

      dengue: this.captacao.doador.coletor.dengue,
      doencaNoFigado: this.captacao.doador.coletor.doencaNoFigado,
      hemorragias: this.captacao.doador.coletor.hemorragias,
      hemofilia: this.captacao.doador.coletor.hemofilia,
      leucemia: this.captacao.doador.coletor.leucemia,
      chikungunya: this.captacao.doador.coletor.chikungunya,
      febreReumatica: this.captacao.doador.coletor.febreReumatica,
      hepatite: this.captacao.doador.coletor.hepatite,
      // hepatiteB: this.captacao.doador.coletor.hepatiteB,
      // hepatiteC: this.captacao.doador.coletor.hepatiteC,
      tuberculose: this.captacao.doador.coletor.tuberculose,
      zika: this.captacao.doador.coletor.zika,
      diabetes: this.captacao.doador.coletor.diabetes,
      doencaNosRins: this.captacao.doador.coletor.doencaNosRins,
      febre: this.captacao.doador.coletor.febre,
      covid: this.captacao.doador.coletor.covid,
      exameFisico1Flag: this.captacao.doador.coletor.exameFisico1Flag,
      exameFisico2Flag: this.captacao.doador.coletor.exameFisico2Flag,
      exameFisico3Flag: this.captacao.doador.coletor.exameFisico3Flag,
      exameFisico4Flag: this.captacao.doador.coletor.exameFisico4Flag,
      exameFisico5Flag: this.captacao.doador.coletor.exameFisico5Flag,
      exameFisico1: this.captacao.doador.coletor.exameFisico1,
      exameFisico2: this.captacao.doador.coletor.exameFisico2,
      exameFisico3: this.captacao.doador.coletor.exameFisico3,
      exameFisico4: this.captacao.doador.coletor.exameFisico4,
      exameFisico5: this.captacao.doador.coletor.exameFisico5,
      desc_transoperatorio: this.captacao.doador.coletor.desc_transoperatorio,
      clivagem: this.captacao.doador.coletor.clivagem,
      profilaxia: this.captacao.doador.coletor.profilaxia,
      proc_anestesico: this.captacao.doador.coletor.proc_anestesico,
      trypanosoma_1: this.captacao.doador.coletor.trypanosoma_1,
      trypanosoma_2: this.captacao.doador.coletor.trypanosoma_2,
      citomegalovirus_1: this.captacao.doador.coletor.citomegalovirus_1,
      citomegalovirus_2: this.captacao.doador.coletor.citomegalovirus_2,
      hiv_1: this.captacao.doador.coletor.hiv_1,
      hiv_2: this.captacao.doador.coletor.hiv_2,
      htlv: this.captacao.doador.coletor.htlv,
      hepatiteB_1: this.captacao.doador.coletor.hepatiteB_1,
      hepatiteB_2: this.captacao.doador.coletor.hepatiteB_2,
      hepatiteB_3: this.captacao.doador.coletor.hepatiteB_3,
      hepatiteB_4: this.captacao.doador.coletor.hepatiteB_4,
      hepatiteC_1: this.captacao.doador.coletor.hepatiteC_1,
      treponemaPallidum_1: this.captacao.doador.coletor.treponemaPallidum_1,
      treponemaPallidum_2: this.captacao.doador.coletor.treponemaPallidum_2,
      toxoplasmaGondii_1: this.captacao.doador.coletor.toxoplasmaGondii_1,
      toxoplasmaGondii_2: this.captacao.doador.coletor.toxoplasmaGondii_2,
      malaria_1: this.captacao.doador.coletor.malaria_1,
      malaria_2: this.captacao.doador.coletor.malaria_2,
      sorologia: this.captacao.doador.coletor.sorologia,
      observacoesHistoricoSaude:
        this.captacao.doador.coletor.observacoesHistoricoSaude,
      observacoesExameFisico:
        this.captacao.doador.coletor.observacoesExameFisico,
      observacoesColeta: this.captacao.doador.coletor.observacoesColeta,
      observacoesDadosLaboratoriais:
        this.captacao.doador.coletor.observacoesDadosLaboratoriais,
      transportadora: this.captacao.doador.coletor.transportadora,
      //dataColeta: this.captacao.doador.coletor.dataColeta,
      inicioProcedimento: this.captacao.doador.coletor.inicioProcedimento,
      fimProcedimento: this.captacao.doador.coletor.fimProcedimento,
      //dataRecebimentoCPC: this.captacao.doador.coletor.dataRecebimentoCPC,
      horarioRecebimentoCPC: this.captacao.doador.coletor.horarioRecebimentoCPC,
      bochechos: this.captacao.doador.coletor.bochechos,
      anestesicoTopico: this.captacao.doador.coletor.anestesicoTopico,
      anestesicoInjetavel: this.captacao.doador.coletor.anestesicoInjetavel,
      anestesicoVasoConstritor:
        this.captacao.doador.coletor.anestesicoVasoConstritor,
      odontoseccao: this.captacao.doador.coletor.odontoseccao,
      remocaoRestauracoes: this.captacao.doador.coletor.remocaoRestauracoes,
      remocaoCaries: this.captacao.doador.coletor.remocaoCaries,

      // desc_Profilaxia: this.captacao.doador.coletor.desc_Profilaxia,
      desc_Bochechos: this.captacao.doador.coletor.desc_Bochechos,
      desc_AnestesicoTopico: this.captacao.doador.coletor.desc_AnestesicoTopico,
      desc_AnestesicoInjetavel:
        this.captacao.doador.coletor.desc_AnestesicoInjetavel,
      desc_AnestesicoConstritor:
        this.captacao.doador.coletor.desc_AnestesicoConstritor,
      desc_FendaClivagem: this.captacao.doador.coletor.desc_FendaClivagem,
      desc_Odontoseccao: this.captacao.doador.coletor.desc_Odontoseccao,
      desc_RemocaoRestauracoes:
        this.captacao.doador.coletor.desc_RemocaoRestauracoes,
      desc_RemocaoCaries: this.captacao.doador.coletor.desc_RemocaoCaries,

      sARS_CoV2_Covid_19_igg:
        this.captacao.doador.coletor.sARS_CoV2_Covid_19_igg,
      sARS_CoV2_Covid_19_igm:
        this.captacao.doador.coletor.sARS_CoV2_Covid_19_igm,
      sARS_CoV2_Covid_pcr: this.captacao.doador.coletor.sARS_CoV2_Covid_pcr,

      outroProfilaxia: this.captacao.doador.coletor.outroProfilaxia,
      outroBochechos: this.captacao.doador.coletor.outroBochechos,
      outroAnestesicoTopico: this.captacao.doador.coletor.outroAnestesicoTopico,
      outroAnestesicoInjetavel:
        this.captacao.doador.coletor.outroAnestesicoInjetavel,
      outroAnestesicoConstritor:
        this.captacao.doador.coletor.outroAnestesicoConstritor,
      clorexidinaPorcentagem:
        this.captacao.doador.coletor.clorexidinaPorcentagem,
      perboratoSodioPorcentagem:
        this.captacao.doador.coletor.perboratoSodioPorcentagem,
      cetilperidinioPorcentagem:
        this.captacao.doador.coletor.cetilperidinioPorcentagem,
      outroBochechoPorcentagem:
        this.captacao.doador.coletor.outroBochechoPorcentagem,
      benzbcainaPorcentagem: this.captacao.doador.coletor.benzbcainaPorcentagem,
      tetracainaPorcentagem: this.captacao.doador.coletor.tetracainaPorcentagem,
      xilocainaPorcentagem: this.captacao.doador.coletor.xilocainaPorcentagem,
      outroAnestesicoTPorcentagem:
        this.captacao.doador.coletor.outroAnestesicoTPorcentagem,
      benzocainaPorcentagem: this.captacao.doador.coletor.benzocainaPorcentagem,
      mepivacainaPorcentagem:
        this.captacao.doador.coletor.mepivacainaPorcentagem,
      prilocainaPorcentagem: this.captacao.doador.coletor.prilocainaPorcentagem,
      citocainaPorcentagem: this.captacao.doador.coletor.citocainaPorcentagem,
      lidocainaPorcentagem: this.captacao.doador.coletor.lidocainaPorcentagem,
      outroAnestesicoIPorcentagem:
        this.captacao.doador.coletor.outroAnestesicoIPorcentagem,
      articainaPorcentagem: this.captacao.doador.coletor.articainaPorcentagem,
      adrenalinaPorcentagem: this.captacao.doador.coletor.adrenalinaPorcentagem,
      noradrenalinaPorcentagem:
        this.captacao.doador.coletor.noradrenalinaPorcentagem,
      cloridratoFenilefrinaPorcentagem:
        this.captacao.doador.coletor.cloridratoFenilefrinaPorcentagem,
      outroAnestesicoCPorcentagem:
        this.captacao.doador.coletor.outroAnestesicoCPorcentagem,
      peroxidoHidrogenioPorcentagem:
        this.captacao.doador.coletor.peroxidoHidrogenioPorcentagem,

      pedraPomes: this.captacao.doador.coletor.pedraPomes,
      pastaPolifatica: this.captacao.doador.coletor.pastaPolifatica,
      outroProfilaxiaCheck: this.captacao.doador.coletor.outroProfilaxiaCheck,
      vestibuloLingual: this.captacao.doador.coletor.vestibuloLingual,
      mesioDistal: this.captacao.doador.coletor.mesioDistal,
      amelocemataria: this.captacao.doador.coletor.amelocemataria,

      clorexidina: this.captacao.doador.coletor.clorexidina,
      perboratoDeSodioBlueM: this.captacao.doador.coletor.perboratoDeSodioBlueM,
      peroxidoDeHidrogenio: this.captacao.doador.coletor.peroxidoDeHidrogenio,
      cetilperidinio: this.captacao.doador.coletor.cetilperidinio,
      outrosBochechoCheck: this.captacao.doador.coletor.outrosBochechoCheck,

      benzocaina: this.captacao.doador.coletor.benzocaina,
      tetracaina: this.captacao.doador.coletor.tetracaina,
      xilocaina: this.captacao.doador.coletor.xilocaina,
      outrosAnestesicoTopicoCheck:
        this.captacao.doador.coletor.outrosAnestesicoTopicoCheck,

      mepivacaina: this.captacao.doador.coletor.mepivacaina,
      prilocaina: this.captacao.doador.coletor.prilocaina,
      articaina: this.captacao.doador.coletor.articaina,
      citocaina: this.captacao.doador.coletor.citocaina,
      lidocaina: this.captacao.doador.coletor.lidocaina,
      outrosAnestesicoInjetavelCheck:
        this.captacao.doador.coletor.outrosAnestesicoInjetavelCheck,

      adrenalina: this.captacao.doador.coletor.adrenalina,
      noradrenalina: this.captacao.doador.coletor.noradrenalina,
      cloridratoDeFenilefrina:
        this.captacao.doador.coletor.cloridratoDeFenilefrina,

      outraDoencaSintoma: this.captacao.doador.coletor.outraDoencaSintoma,
      outraDoencaSintomaCheck:
        this.captacao.doador.coletor.outraDoencaSintomaCheck,
      naoDoencaSintomaCheck: this.captacao.doador.coletor.naoDoencaSintomaCheck,

      sifilisvdrl: this.captacao.doador.coletor.sifilisvdrl,
      pcrqualitativocmv: this.captacao.doador.coletor.pcrqualitativocmv,
      pcrquantitativohepatiteb:
        this.captacao.doador.coletor.pcrquantitativohepatiteb,
      pcrqualitativohepatitec:
        this.captacao.doador.coletor.pcrqualitativohepatitec,
      pcrqualitativohiv: this.captacao.doador.coletor.pcrqualitativohiv,
      pcrhtlv1: this.captacao.doador.coletor.pcrhtlv1,
      pcrhtlv2: this.captacao.doador.coletor.pcrhtlv2,
      pcrqualitativoepsteinbarr:
        this.captacao.doador.coletor.pcrqualitativoepsteinbarr,
      examesadicionais: this.captacao.doador.coletor.examesadicionais,

      outrosAnestesicoVasoConstritor:
        this.captacao.doador.coletor.outrosAnestesicoVasoConstritor,
      porcentagemOutrosAnestesicoVasoConstritor:
        this.captacao.doador.coletor.porcentagemOutrosAnestesicoVasoConstritor,
      outrosAnestesicoVasoConstritorDesc:
        this.captacao.doador.coletor.outrosAnestesicoVasoConstritorDesc,
    });
  }

  resetarFormSemCPF() {
    this.formatacoesDatasNascimentos();

    this.dadosCadastraisForm.get("doador").patchValue({
      nome: this.captacao.doador.doador.nome,
      rg: this.captacao.doador.doador.rg,
      estadoCivil: this.captacao.doador.doador.estadoCivil,
      nacionalidade: this.captacao.doador.doador.nacionalidade,
      sexo: this.captacao.doador.doador.sexo,
      estado: this.captacao.doador.doador.estado,
      profissao: this.captacao.doador.doador.profissao,
      rh: this.captacao.doador.doador.rh,
      tipagemSanguinea: this.captacao.doador.doador.tipagemSanguinea,
      email: this.captacao.doador.doador.email,
      cep: this.captacao.doador.doador.cep,
      endereco: this.captacao.doador.doador.endereco,
      bairro: this.captacao.doador.doador.bairro,
      cidade: this.captacao.doador.doador.cidade,
      numEndereco: this.captacao.doador.doador.numEndereco,
      complemento: this.captacao.doador.doador.complemento,
      telefone: this.captacao.doador.doador.telefone,
      telefoneCelular: this.captacao.doador.doador.telefoneCelular,
      telefoneComercial: this.captacao.doador.doador.telefoneComercial,
      observacoes: this.captacao.doador.doador.observacoes,
      taxaContrato: this.captacao.doador.doador.taxaContrato,
    });
    this.dadosCadastraisForm.get("captacao").patchValue({
      destinoTecidosDuros: this.captacao.doador.coletor.destinoTecidosDuros,
      destinoMaterialBiologico:
        this.captacao.doador.coletor.destinoMaterialBiologico,
      doacaoPesquisa: this.captacao.doador.coletor.doacaoPesquisa,
      nomeResponsavel1: this.captacao.doador.coletor.nomeResponsavel1,
      grauDeParentescoResponsavel1:
        this.captacao.doador.coletor.grauDeParentescoResponsavel1,
      cpfResponsavel1: this.captacao.doador.coletor.cpfResponsavel1,
      rgResponsavel1: this.captacao.doador.coletor.rgResponsavel1,
      emailResponsavel1: this.captacao.doador.coletor.emailResponsavel1,
      telefoneResponsavel1: this.captacao.doador.coletor.telefoneResponsavel1,
      telefoneCelularResponsavel1:
        this.captacao.doador.coletor.telefoneCelularResponsavel1,
      cepResponsavel1: this.captacao.doador.coletor.cepResponsavel1,
      enderecoResponsavel1: this.captacao.doador.coletor.enderecoResponsavel1,
      complementoResponsavel1:
        this.captacao.doador.coletor.complementoResponsavel1,
      bairroResponsavel1: this.captacao.doador.coletor.bairroResponsavel1,
      cidadeResponsavel1: this.captacao.doador.coletor.cidadeResponsavel1,
      estadoResponsavel1: this.captacao.doador.coletor.estadoResponsavel1,
      numEnderecoResponsavel1:
        this.captacao.doador.coletor.numEnderecoResponsavel1,
      estadoCivilResp1: this.captacao.doador.coletor.estadoCivilResp1,
      nacionalidadeResp1: this.captacao.doador.coletor.nacionalidadeResp1,
      profissaoResp1: this.captacao.doador.coletor.profissaoResp1,
      grauParentescoResp1: this.captacao.doador.coletor.grauParentescoResp1,

      nomeResponsavel2: this.captacao.doador.coletor.nomeResponsavel2,
      grauDeParentescoResponsavel2:
        this.captacao.doador.coletor.grauDeParentescoResponsavel2,
      cpfResponsavel2: this.captacao.doador.coletor.cpfResponsavel2,
      rgResponsavel2: this.captacao.doador.coletor.rgResponsavel2,
      emailResponsavel2: this.captacao.doador.coletor.emailResponsavel2,
      telefoneResponsavel2: this.captacao.doador.coletor.telefoneResponsavel2,
      telefoneCelularResponsavel2:
        this.captacao.doador.coletor.telefoneCelularResponsavel2,
      cepResponsavel2: this.captacao.doador.coletor.cepResponsavel2,
      enderecoResponsavel2: this.captacao.doador.coletor.enderecoResponsavel2,
      complementoResponsavel2:
        this.captacao.doador.coletor.complementoResponsavel2,
      bairroResponsavel2: this.captacao.doador.coletor.bairroResponsavel2,
      cidadeResponsavel2: this.captacao.doador.coletor.cidadeResponsavel2,
      estadoResponsavel2: this.captacao.doador.coletor.estadoResponsavel2,
      numEnderecoResponsavel2:
        this.captacao.doador.coletor.numEnderecoResponsavel2,
      estadoCivilResp2: this.captacao.doador.coletor.estadoCivilResp2,
      nacionalidadeResp2: this.captacao.doador.coletor.nacionalidadeResp2,
      profissaoResp2: this.captacao.doador.coletor.profissaoResp2,
      grauParentescoResp2: this.captacao.doador.coletor.grauParentescoResp2,

      //dataExamesSanguineos: this.captacao.doador.coletor.dataExamesSanguineos,
      paiFlag: this.captacao.doador.coletor.paiFlag,
      descPai: this.captacao.doador.coletor.descPai,
      hemograma: this.captacao.doador.coletor.hemograma,
      localCaptacao: this.captacao.doador.coletor.localCaptacao,
      descricaoLocalColeta: this.captacao.doador.coletor.descricaoLocalColeta,
      historiaMedicaSocial1Flag:
        this.captacao.doador.coletor.historiaMedicaSocial1Flag,
      historiaMedicaSocial2Flag:
        this.captacao.doador.coletor.historiaMedicaSocial2Flag,
      historiaMedicaSocial3Flag:
        this.captacao.doador.coletor.historiaMedicaSocial3Flag,
      historiaMedicaSocial4Flag:
        this.captacao.doador.coletor.historiaMedicaSocial4Flag,
      historiaMedicaSocial5Flag:
        this.captacao.doador.coletor.historiaMedicaSocial5Flag,
      historiaMedicaSocial6Flag:
        this.captacao.doador.coletor.historiaMedicaSocial6Flag,
      historiaMedicaSocial7Flag:
        this.captacao.doador.coletor.historiaMedicaSocial7Flag,
      historiaMedicaSocial8Flag:
        this.captacao.doador.coletor.historiaMedicaSocial8Flag,
      historiaMedicaSocial9Flag:
        this.captacao.doador.coletor.historiaMedicaSocial9Flag,
      historiaMedicaSocial10Flag:
        this.captacao.doador.coletor.historiaMedicaSocial10Flag,
      historiaMedicaSocial1: this.captacao.doador.coletor.historiaMedicaSocial1,
      historiaMedicaSocial2: this.captacao.doador.coletor.historiaMedicaSocial2,
      historiaMedicaSocial3: this.captacao.doador.coletor.historiaMedicaSocial3,
      historiaMedicaSocial4: this.captacao.doador.coletor.historiaMedicaSocial4,
      historiaMedicaSocial5: this.captacao.doador.coletor.historiaMedicaSocial5,
      historiaMedicaSocial6: this.captacao.doador.coletor.historiaMedicaSocial6,
      historiaMedicaSocial7: this.captacao.doador.coletor.historiaMedicaSocial7,
      historiaMedicaSocial8: this.captacao.doador.coletor.historiaMedicaSocial8,
      historiaMedicaSocial9: this.captacao.doador.coletor.historiaMedicaSocial9,
      historiaMedicaSocial10:
        this.captacao.doador.coletor.historiaMedicaSocial10,
      anemia: this.captacao.doador.coletor.anemia,
      dengue: this.captacao.doador.coletor.dengue,
      doencaNoFigado: this.captacao.doador.coletor.doencaNoFigado,
      hemorragias: this.captacao.doador.coletor.hemorragias,
      hemofilia: this.captacao.doador.coletor.hemofilia,
      leucemia: this.captacao.doador.coletor.leucemia,
      chikungunya: this.captacao.doador.coletor.chikungunya,
      febreReumatica: this.captacao.doador.coletor.febreReumatica,
      hepatite: this.captacao.doador.coletor.hepatite,
      // hepatiteB: this.captacao.doador.coletor.hepatiteB,
      // hepatiteC: this.captacao.doador.coletor.hepatiteC,
      tuberculose: this.captacao.doador.coletor.tuberculose,
      zika: this.captacao.doador.coletor.zika,
      diabetes: this.captacao.doador.coletor.diabetes,
      doencaNosRins: this.captacao.doador.coletor.doencaNosRins,
      febre: this.captacao.doador.coletor.febre,
      covid: this.captacao.doador.coletor.covid,
      exameFisico1Flag: this.captacao.doador.coletor.exameFisico1Flag,
      exameFisico2Flag: this.captacao.doador.coletor.exameFisico2Flag,
      exameFisico3Flag: this.captacao.doador.coletor.exameFisico3Flag,
      exameFisico4Flag: this.captacao.doador.coletor.exameFisico4Flag,
      exameFisico5Flag: this.captacao.doador.coletor.exameFisico5Flag,
      exameFisico1: this.captacao.doador.coletor.exameFisico1,
      exameFisico2: this.captacao.doador.coletor.exameFisico2,
      exameFisico3: this.captacao.doador.coletor.exameFisico3,
      exameFisico4: this.captacao.doador.coletor.exameFisico4,
      exameFisico5: this.captacao.doador.coletor.exameFisico5,
      desc_transoperatorio: this.captacao.doador.coletor.desc_transoperatorio,
      clivagem: this.captacao.doador.coletor.clivagem,
      profilaxia: this.captacao.doador.coletor.profilaxia,
      proc_anestesico: this.captacao.doador.coletor.proc_anestesico,
      trypanosoma_1: this.captacao.doador.coletor.trypanosoma_1,
      trypanosoma_2: this.captacao.doador.coletor.trypanosoma_2,
      citomegalovirus_1: this.captacao.doador.coletor.citomegalovirus_1,
      citomegalovirus_2: this.captacao.doador.coletor.citomegalovirus_2,
      hiv_1: this.captacao.doador.coletor.hiv_1,
      hiv_2: this.captacao.doador.coletor.hiv_2,
      htlv: this.captacao.doador.coletor.htlv,
      hepatiteB_1: this.captacao.doador.coletor.hepatiteB_1,
      hepatiteB_2: this.captacao.doador.coletor.hepatiteB_2,
      hepatiteB_3: this.captacao.doador.coletor.hepatiteB_3,
      hepatiteB_4: this.captacao.doador.coletor.hepatiteB_4,
      hepatiteC_1: this.captacao.doador.coletor.hepatiteC_1,
      treponemaPallidum_1: this.captacao.doador.coletor.treponemaPallidum_1,
      treponemaPallidum_2: this.captacao.doador.coletor.treponemaPallidum_2,
      toxoplasmaGondii_1: this.captacao.doador.coletor.toxoplasmaGondii_1,
      toxoplasmaGondii_2: this.captacao.doador.coletor.toxoplasmaGondii_2,
      malaria_1: this.captacao.doador.coletor.malaria_1,
      malaria_2: this.captacao.doador.coletor.malaria_2,
      sorologia: this.captacao.doador.coletor.sorologia,
      observacoesHistoricoSaude:
        this.captacao.doador.coletor.observacoesHistoricoSaude,
      observacoesExameFisico:
        this.captacao.doador.coletor.observacoesExameFisico,
      observacoesColeta: this.captacao.doador.coletor.observacoesColeta,
      observacoesDadosLaboratoriais:
        this.captacao.doador.coletor.observacoesDadosLaboratoriais,
      transportadora: this.captacao.doador.coletor.transportadora,
      //dataColeta: this.captacao.doador.coletor.dataColeta,
      inicioProcedimento: this.captacao.doador.coletor.inicioProcedimento,
      fimProcedimento: this.captacao.doador.coletor.fimProcedimento,
      //dataRecebimentoCPC: this.captacao.doador.coletor.dataRecebimentoCPC,
      horarioRecebimentoCPC: this.captacao.doador.coletor.horarioRecebimentoCPC,
      bochechos: this.captacao.doador.coletor.bochechos,
      anestesicoTopico: this.captacao.doador.coletor.anestesicoTopico,
      anestesicoInjetavel: this.captacao.doador.coletor.anestesicoInjetavel,
      anestesicoVasoConstritor:
        this.captacao.doador.coletor.anestesicoVasoConstritor,
      odontoseccao: this.captacao.doador.coletor.odontoseccao,
      remocaoRestauracoes: this.captacao.doador.coletor.remocaoRestauracoes,
      remocaoCaries: this.captacao.doador.coletor.remocaoCaries,

      // desc_Profilaxia: this.captacao.doador.coletor.desc_Profilaxia,
      desc_Bochechos: this.captacao.doador.coletor.desc_Bochechos,
      desc_AnestesicoTopico: this.captacao.doador.coletor.desc_AnestesicoTopico,
      desc_AnestesicoInjetavel:
        this.captacao.doador.coletor.desc_AnestesicoInjetavel,
      desc_AnestesicoConstritor:
        this.captacao.doador.coletor.desc_AnestesicoConstritor,
      desc_FendaClivagem: this.captacao.doador.coletor.desc_FendaClivagem,
      desc_Odontoseccao: this.captacao.doador.coletor.desc_Odontoseccao,
      desc_RemocaoRestauracoes:
        this.captacao.doador.coletor.desc_RemocaoRestauracoes,
      desc_RemocaoCaries: this.captacao.doador.coletor.desc_RemocaoCaries,

      sARS_CoV2_Covid_19_igg:
        this.captacao.doador.coletor.sARS_CoV2_Covid_19_igg,
      sARS_CoV2_Covid_19_igm:
        this.captacao.doador.coletor.sARS_CoV2_Covid_19_igm,

      outroProfilaxia: this.captacao.doador.coletor.outroProfilaxia,
      outroBochechos: this.captacao.doador.coletor.outroBochechos,
      outroAnestesicoTopico: this.captacao.doador.coletor.outroAnestesicoTopico,
      outroAnestesicoInjetavel:
        this.captacao.doador.coletor.outroAnestesicoInjetavel,
      outroAnestesicoConstritor:
        this.captacao.doador.coletor.outroAnestesicoConstritor,
      clorexidinaPorcentagem:
        this.captacao.doador.coletor.clorexidinaPorcentagem,
      perboratoSodioPorcentagem:
        this.captacao.doador.coletor.perboratoSodioPorcentagem,
      cetilperidinioPorcentagem:
        this.captacao.doador.coletor.cetilperidinioPorcentagem,
      outroBochechoPorcentagem:
        this.captacao.doador.coletor.outroBochechoPorcentagem,
      benzbcainaPorcentagem: this.captacao.doador.coletor.benzbcainaPorcentagem,
      tetracainaPorcentagem: this.captacao.doador.coletor.tetracainaPorcentagem,
      xilocainaPorcentagem: this.captacao.doador.coletor.xilocainaPorcentagem,
      outroAnestesicoTPorcentagem:
        this.captacao.doador.coletor.outroAnestesicoTPorcentagem,
      benzocainaPorcentagem: this.captacao.doador.coletor.benzocainaPorcentagem,
      mepivacainaPorcentagem:
        this.captacao.doador.coletor.mepivacainaPorcentagem,
      prilocainaPorcentagem: this.captacao.doador.coletor.prilocainaPorcentagem,
      citocainaPorcentagem: this.captacao.doador.coletor.citocainaPorcentagem,
      lidocainaPorcentagem: this.captacao.doador.coletor.lidocainaPorcentagem,
      outroAnestesicoIPorcentagem:
        this.captacao.doador.coletor.outroAnestesicoIPorcentagem,
      articainaPorcentagem: this.captacao.doador.coletor.articainaPorcentagem,
      adrenalinaPorcentagem: this.captacao.doador.coletor.adrenalinaPorcentagem,
      noradrenalinaPorcentagem:
        this.captacao.doador.coletor.noradrenalinaPorcentagem,
      cloridratoFenilefrinaPorcentagem:
        this.captacao.doador.coletor.cloridratoFenilefrinaPorcentagem,
      outroAnestesicoCPorcentagem:
        this.captacao.doador.coletor.outroAnestesicoCPorcentagem,
      peroxidoHidrogenioPorcentagem:
        this.captacao.doador.coletor.peroxidoHidrogenioPorcentagem,

      pedraPomes: this.captacao.doador.coletor.pedraPomes,
      pastaPolifatica: this.captacao.doador.coletor.pastaPolifatica,
      outroProfilaxiaCheck: this.captacao.doador.coletor.outroProfilaxiaCheck,
      vestibuloLingual: this.captacao.doador.coletor.vestibuloLingual,
      mesioDistal: this.captacao.doador.coletor.mesioDistal,
      amelocemataria: this.captacao.doador.coletor.amelocemataria,

      clorexidina: this.captacao.doador.coletor.clorexidina,
      perboratoDeSodioBlueM: this.captacao.doador.coletor.perboratoDeSodioBlueM,
      peroxidoDeHidrogenio: this.captacao.doador.coletor.peroxidoDeHidrogenio,
      cetilperidinio: this.captacao.doador.coletor.cetilperidinio,
      outrosBochechoCheck: this.captacao.doador.coletor.outrosBochechoCheck,

      benzocaina: this.captacao.doador.coletor.benzocaina,
      tetracaina: this.captacao.doador.coletor.tetracaina,
      xilocaina: this.captacao.doador.coletor.xilocaina,
      outrosAnestesicoTopicoCheck:
        this.captacao.doador.coletor.outrosAnestesicoTopicoCheck,

      mepivacaina: this.captacao.doador.coletor.mepivacaina,
      prilocaina: this.captacao.doador.coletor.prilocaina,
      articaina: this.captacao.doador.coletor.articaina,
      citocaina: this.captacao.doador.coletor.citocaina,
      lidocaina: this.captacao.doador.coletor.lidocaina,
      outrosAnestesicoInjetavelCheck:
        this.captacao.doador.coletor.outrosAnestesicoInjetavelCheck,

      adrenalina: this.captacao.doador.coletor.adrenalina,
      noradrenalina: this.captacao.doador.coletor.noradrenalina,
      cloridratoDeFenilefrina:
        this.captacao.doador.coletor.cloridratoDeFenilefrina,

      outraDoencaSintoma: this.captacao.doador.coletor.outraDoencaSintoma,
      outraDoencaSintomaCheck:
        this.captacao.doador.coletor.outraDoencaSintomaCheck,
      naoDoencaSintomaCheck: this.captacao.doador.coletor.naoDoencaSintomaCheck,

      outrosAnestesicoVasoConstritor:
        this.captacao.doador.coletor.outrosAnestesicoVasoConstritor,
      porcentagemOutrosAnestesicoVasoConstritor:
        this.captacao.doador.coletor.porcentagemOutrosAnestesicoVasoConstritor,
      outrosAnestesicoVasoConstritorDesc:
        this.captacao.doador.coletor.outrosAnestesicoVasoConstritorDesc,
    });
  }
  resetarForm() {
    if (this.status === "Editando...") {
      this.resetarFormSemCPF();
    } else {
      this.dadosCadastraisForm.reset();
      this.dadosCadastraisForm
        .get("doador")
        .patchValue({ cpf: this.cpfString });
    }
    this.habilitarBotoes = false;
    this.desabilitarBotoes = true;
  }

  habilitaBotoes() {
    this.dadosCadastraisForm.valueChanges.subscribe(() => {
      this.desabilitarBotoes = false;
      if (this.desablititarBotaoFinalizarColeta) {
        this.desabilitarBotoes = true;
      }
    });
  }

  validacaoContratovalido() {
    if (!this.maiorDeIdade) {
      this.validacaoMenorIdade();
      return;
    }

    this.validacaoMaiorIdade();
    return;
  }

  validacaoMenorIdadeResps(): boolean {
    console.log("validacaoMenorIdadeResps");
    // if (!this.captacao.doador) return;

    // if (this.dadosCadastraisForm.get("captacao.nomeResponsavel2").value) {
    //   this.validacaoMenorIdadeResp2();
    //   return true;
    // }
    // if (
    //   this.dadosCadastraisForm.get("doador").valid &&
    //   this.dadosCadastraisForm.get("captacao").valid
    // ) {
    //   this.contratoValido = true;
    //   return true;
    // }
    // this.contratoValido = false;
    return true;
  }

  validacaoMenorIdadeResp2() {
    // if (
    //   this.dadosCadastraisForm.get("doador").valid &&
    //   this.dadosCadastraisForm.get("captacao").valid &&
    //   this.validacaoResp2()
    // ) {
    //   this.contratoValido = true;
    //   return;
    // }
    // this.contratoValido = false;
    console.log("validacaoMenorIdadeResp2");
    return;
  }

  verificarContratoTermoValido() {
    console.log("verificarContratoTermoValido");
    if (this.contratoValido) {
      return;
    }
  }

  desabilatarBotoesAoSalvar() {
    setTimeout(() => {
      this.desabilitarBotoes = true;
      this.habilitarBotoes = false;
    }, 300);
  }

  tecidosRelacionados(jsonCaptacao) {
    if (jsonCaptacao[0].codigo == null) {
      this.validacaoTecidos = false;
      return;
    } else {
      this.validacaoTecidos = true;
    }
    for (let i = 0; i < jsonCaptacao.length; i++) {
      this.captacaoTecidosCaptados.push(jsonCaptacao[i]);
    }
  }

  listarTecidosRelacionados() {
    if (!this.captacao.doador) return;
    let jsonCaptacao = JSON.parse(
      JSON.stringify(this.captacao.doador.tecidos.tecidoCaptado)
    );
    this.tecidosRelacionados(jsonCaptacao);
  }

  ngOnInit(): void {
    this.verificarFlagEdicao();
    // this.verificarContratoTermoValido();
    this.listarTecidosRelacionados();
    this.idadeDoador();
    this.validacoesFinalizarColeta();
    this.datasValidacoes();
    this.cpfsValidacoes();
    this.statusColeta();
    this.inputCPFDesabilitado();
    this.consultaCPF();
    this.validacaoContratovalido();
    // this.validaTermo();
    this.validacaoColetaBotao();
    this.validaTermoValidoBotaoColeta();
    this.validaFlagTermo();
    // this.horarioProcedimentoMaior();
  }

  ngAfterViewInit() {
    this.habilitaBotoes();
    this.finalizarEdicaoCliente();
    this.finalizarEdicaoColeta();
  }

  horarioProcedimentoInicioMaior(): boolean {
    if (
      !this.dadosCadastraisForm.get("captacao.inicioProcedimento").value ||
      !this.dadosCadastraisForm.get("captacao.fimProcedimento").value
    )
      return;
    let inicioProcedimento = this.dadosCadastraisForm
      .get("captacao.inicioProcedimento")
      .value.split(":");
    let fimProcedimento = this.dadosCadastraisForm
      .get("captacao.fimProcedimento")
      .value.split(":");
    let inicioProcedimentoSemSegundos =
      inicioProcedimento[0] + inicioProcedimento[1];
    let fimProcedimentoSemSegundos = fimProcedimento[0] + fimProcedimento[1];

    if (inicioProcedimentoSemSegundos > fimProcedimentoSemSegundos) {
      const dialogRef = this.dialog.open(ErrorAlertComponent, {
        width: "300px",
        data: {
          name: "O horário de início do procedimento precisa ser inferior ao fim!",
        },
      });
      return true;
    }
    return false;
  }
  resetarTecidosCaptadosAoSalvar() {
    let control = this.dadosCadastraisForm.get("tecidoCaptado") as FormGroup;
    let array = control.get("tecidos") as FormArray;

    for (let i = 0; i < array.controls.length; i++) {
      if (array.at(i)) {
        array.at(i).patchValue({
          codigo: "",
          nome: "",
          acao: "",
          codigoCaptacao: "",
        });
      }
    }
  }

  finalizarColeta() {
    const message = `Deseja finalizar a Coleta? Não poderá ser alterada novamente! `;

    const dialogData = new ConfirmDialogModel(
      "Finalizar Coleta",
      message,
      "Finalizar"
    );

    const dialogRef = this.dialog.open(ConfirmacaoComponent, {
      maxWidth: "400px",
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe((dialogResult) => {
      this.result = dialogResult;
      if (this.result == "true") {
        this.dadosCadastraisForm.get("editarWeb").patchValue("0");
        this.dadosCadastraisForm.disable();
        this.editarWeb = false;
        this.submit();
      }
    });
  }

  verificarFlagEdicao() {
    if (!this.captacao.doador) return;

    this.flagEdCliente = this.captacao.doador.doador.editarCliente;
    this.flagEdColeta = this.captacao.doador.coletor.editarColeta;
    if (this.flagEdCliente === "0") {
      this.finalizarCliente = true;
      this.dadosCadastraisForm.get("doador").disable();
      this.desabilitarFormResps();
    }

    if (this.flagEdColeta === "0") {
      this.finalizarEdColeta = false;
      this.termoValido = true;
      this.desabilitarColeta();
    }

    if (this.flagEdCliente === "0" && this.flagEdColeta === "0") {
      this.fichaValida = true;
    }
  }

  gerarPDF() {
    const pdfModal = this.pdf
      .open(PdfContratoCreateComponent, {
        data: {
          doador: this.captacao.doador.doador
            ? this.captacao.doador.doador
            : this.captacao.doador,
          coletor: this.captacao.doador.coletor
            ? this.captacao.doador.coletor
            : this.captacao.coletor,
          coletaValida: this.finalizarCliente,
        },
      })
      .close();
  }

  gerarPDFAprovacao() {
    const pdfModal = this.pdf
      .open(PdfTermoCreateComponent, {
        data: {
          doador: this.captacao.doador.doador
            ? this.captacao.doador.doador
            : this.captacao.doador,
          coletor: this.captacao.doador.coletor
            ? this.captacao.doador.coletor
            : this.captacao.coletor,
          listaTecidosCapatados: this.captacao.doador.doador
            ? this.captacaoTecidosCaptados
            : this.captacao.tecidos.tecidoCaptado,
          termoValido: this.termoValido,
        },
      })
      .close();
  }

  gerarPDFTriagem() {
    const pdfModal = this.pdf
      .open(PdfFichaCreateComponent, {
        data: {
          doador: this.captacao.doador.doador
            ? this.captacao.doador.doador
            : this.captacao.doador,
          coletor: this.captacao.doador.coletor
            ? this.captacao.doador.coletor
            : this.captacao.coletor,
          listaTecidosCapatados: this.captacao.doador.doador
            ? this.captacaoTecidosCaptados
            : this.captacao.tecidos.tecidoCaptado,
          fichaValida: this.fichaValida,
        },
      })
      .close();
  }

  idadeDoador() {
    if (!this.captacao.doador) {
      this.idadeDoadorCadastro();
    } else {
      this.idadeDoadorCadastrado();
    }
  }

  idadeDoadorCadastro() {
    this.dadosCadastraisForm.valueChanges.subscribe(() => {
      let dataNascimento = this.dadosCadastraisForm.get(
        "doador.dataNascimento"
      ).value;
      if (!dataNascimento) {
        return;
      }
      this.idadeDoadorCadastrando(dataNascimento);
    });
  }

  idadeDoadorCadastrado() {
    let dataNascimento = this.captacao.doador.doador.dataNascimento;
    if (!dataNascimento) return;
    let dataN = dataNascimento.split("-");
    let dataA = dataN[0];
    let dataM = dataN[1];
    let dataD = dataN[2];
    let date = new Date();
    let dataNFormatada = `${dataM}/${dataD}/${dataA}`;

    let dataNascimentoFormatada = new Date(dataNFormatada);

    let idade = parseInt(
      this.calcularIdade(dataNascimentoFormatada, date) + ""
    );
    if (idade >= 18) {
      this.maiorDeIdade = true;
    }
  }

  idadeDoadoUpdate(res: Doador) {
    let dataNascimento = res.dataNascimento;
    if (!dataNascimento) return;
    let dataN = dataNascimento.split("-");
    let dataA = dataN[0];
    let dataM = dataN[1];
    let dataD = dataN[2];
    let date = new Date();
    let dataNFormatada = `${dataM}/${dataD}/${dataA}`;

    let dataNascimentoFormatada = new Date(dataNFormatada);
    let idade = parseInt(
      this.calcularIdade(dataNascimentoFormatada, date) + ""
    );
    if (idade >= 18) {
      this.maiorDeIdade = true;
    } else {
      this.maiorDeIdade = false;
    }
  }

  idadeDoadorCadastrando(doadorDataNascimento) {
    let dataN = doadorDataNascimento.split("/");

    let dataA = dataN[2];
    let dataM = dataN[1];
    let dataD = dataN[0];
    let date = new Date();
    let dataNFormatada = `${dataM}/${dataD}/${dataA}`;

    let dataNascimentoFormatada = new Date(dataNFormatada);
    let idade = parseInt(
      this.calcularIdade(dataNascimentoFormatada, date) + ""
    );
    if (idade >= 18) {
      this.maiorDeIdade = true;
    } else {
      this.maiorDeIdade = false;
    }
  }

  verificacaoIdadeResp(): boolean {
    if (
      !this.idadeResposaveisCadastrado("captacao.dataNascimentoResponsavel1") ||
      !this.idadeResposaveisCadastrado("captacao.dataNascimentoResponsavel2")
    ) {
      return false;
    }
    return true;
  }

  idadeResposaveisCadastrado(dataNascimentoResp): boolean {
    let dataNascimento = this.dadosCadastraisForm.get(dataNascimentoResp).value;
    if (!dataNascimento) {
      return true;
    }
    let dataN = dataNascimento.split("/");
    let dataA = dataN[2];
    let dataM = dataN[1];
    let dataD = dataN[0];
    let date = new Date();
    let dataNFormatada = `${dataM}/${dataD}/${dataA}`;

    let dataNascimentoFormatada = new Date(dataNFormatada);
    let idade = parseInt(
      this.calcularIdade(dataNascimentoFormatada, date) + ""
    );
    if (idade >= 18) {
      return true;
    }
    const dialogRef = this.dialog.open(ErrorAlertComponent, {
      width: "300px",
      data: { name: "O responsável precisa ser maior de idade!" },
    });
    return false;
  }

  idadeResponsaveisCadastrando(resposavelDataNascimento): boolean {
    if (!resposavelDataNascimento) return true;
    let dataN = resposavelDataNascimento.split("/");
    let dataA = dataN[2];
    let dataM = dataN[1];
    let dataD = dataN[0];
    let date = new Date();
    let dataNFormatada = `${dataM}/${dataD}/${dataA}`;

    let dataNascimentoFormatada = new Date(dataNFormatada);
    let idade = parseInt(
      this.calcularIdade(dataNascimentoFormatada, date) + ""
    );
    if (idade >= 18) {
      return true;
    }
    return false;
  }

  idadeResponsaveisCadastro(): boolean {
    if (
      !this.idadeResponsaveisCadastrando(
        this.dadosCadastraisForm.get("captacao.dataNascimentoResponsavel1")
          .value
      ) ||
      !this.idadeResponsaveisCadastrando(
        this.dadosCadastraisForm.get("captacao.dataNascimentoResponsavel2")
          .value
      )
    ) {
      const dialogRef = this.dialog.open(ErrorAlertComponent, {
        width: "300px",
        data: { name: "O responsável precisa ser maior de idade!" },
      });
      return false;
    }
    return true;
  }

  calcularIdade(nascimento, hoje) {
    var idade = hoje.getFullYear() - nascimento.getFullYear();
    if (
      new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate()) <
      new Date(hoje.getFullYear(), nascimento.getMonth(), nascimento.getDate())
    )
      idade--;
    return idade;
  }

  validacoesFinalizarColeta() {
    if (!this.captacao.doador) {
      return;
    }
    // if(!this.editarWeb){
    //   this.botaoFinalizarColeta = true;
    //   return;
    // }
    if (this.maiorDeIdade) {
      this.validacaoMaiorIdade();
    } else {
      this.validacaoMenorIdade();
    }
  }

  validacaoMaiorIdade() {
    console.log("validacaoMaiorIdade");
    if (this.dadosCadastraisForm.get("doador").valid && this.maiorDeIdade) {
      this.contratoValido = true;
      return;
    }

    this.contratoValido = false;
    return;
    // if (this.maiorDeIdade && this.dadosCadastraisForm.get("doador").valid) {
    //   this.contratoValido = true;
    //   return;
    // }
    // this.contratoValido = false;
    return;
  }

  validacaoMenorIdade() {
    console.log("validacaoMenorIdade");
    if (
      this.dadosCadastraisForm.get("doador").valid &&
      this.responsavel1Valido()
    ) {
      this.contratoValido = true;
      return;
    }

    this.contratoValido = false;
    return;
  }

  //TODO: melhorar isso auqi se for possivel. Tem q separar o form em mais grupos, e os reposaveis ir para grupos diferentes dentro do doador
  private responsavel1Valido(): boolean {
    let verificacaoCampos =
      this.dadosCadastraisForm.get("captacao.cpfResponsavel1").value &&
      this.dadosCadastraisForm.get("captacao.rgResponsavel1").value &&
      this.dadosCadastraisForm.get("captacao.emailResponsavel1").value &&
      this.dadosCadastraisForm.get("captacao.telefoneCelularResponsavel1")
        .value &&
      this.dadosCadastraisForm.get("captacao.cepResponsavel1").value &&
      this.dadosCadastraisForm.get("captacao.enderecoResponsavel1").value &&
      this.dadosCadastraisForm.get("captacao.bairroResponsavel1").value &&
      this.dadosCadastraisForm.get("captacao.cidadeResponsavel1").value &&
      this.dadosCadastraisForm.get("captacao.estadoResponsavel1").value &&
      this.dadosCadastraisForm.get("captacao.numEnderecoResponsavel1").value &&
      this.dadosCadastraisForm.get("captacao.estadoCivilResp1").value &&
      this.dadosCadastraisForm.get("captacao.nacionalidadeResp1").value &&
      this.dadosCadastraisForm.get("captacao.profissaoResp1").value &&
      this.dadosCadastraisForm.get("captacao.grauParentescoResp1").value;

    return verificacaoCampos;
  }

  //Melhorar
  validacaoResp2(): boolean {
    // let verificacaoCampos =
    //   this.dadosCadastraisForm.get("captacao.cpfResponsavel2").value &&
    //   this.dadosCadastraisForm.get("captacao.rgResponsavel2").value &&
    //   this.dadosCadastraisForm.get("captacao.emailResponsavel2").value &&
    //   this.dadosCadastraisForm.get("captacao.telefoneCelularResponsavel2")
    //     .value &&
    //   this.dadosCadastraisForm.get("captacao.cepResponsavel2").value &&
    //   this.dadosCadastraisForm.get("captacao.enderecoResponsavel2").value &&
    //   this.dadosCadastraisForm.get("captacao.bairroResponsavel2").value &&
    //   this.dadosCadastraisForm.get("captacao.cidadeResponsavel2").value &&
    //   this.dadosCadastraisForm.get("captacao.estadoResponsavel2").value &&
    //   this.dadosCadastraisForm.get("captacao.numEnderecoResponsavel2").value &&
    //   this.dadosCadastraisForm.get("captacao.estadoCivilResp2").value &&
    //   this.dadosCadastraisForm.get("captacao.nacionalidadeResp2").value &&
    //   this.dadosCadastraisForm.get("captacao.profissaoResp2").value &&
    //   this.dadosCadastraisForm.get("captacao.grauParentescoResp2").value;

    // if (verificacaoCampos) {
    return true;
    // }
    // return false;
  }

  //Refatorar assim que possível!
  validacaoColeta(): boolean {
    console.log("valida");
    console.log(
      this.dadosCadastraisForm.get("captacao.destinoTecidosDuros").value
    );
    console.log(
      this.dadosCadastraisForm.get("captacao.destinoMaterialBiologico").value
    );
    console.log(this.dadosCadastraisForm.get("captacao.doacaoPesquisa").value);

    if (
      this.dadosCadastraisForm.get("captacao.destinoTecidosDuros").value ==
        "1" &&
      this.dadosCadastraisForm.get("captacao.destinoMaterialBiologico").value ==
        "1" &&
      !this.dadosCadastraisForm.get("captacao.doacaoPesquisa").value
    ) {
      this.dadosCadastraisForm
        .get("captacao.doacaoPesquisa")
        .setValidators([Validators.required]);
      return false;
    }

    let verificacaoCamposColeta =
      this.dadosCadastraisForm.get("captacao.transportadora").value &&
      this.dadosCadastraisForm.get("captacao.dataColeta").value &&
      this.dadosCadastraisForm.get("captacao.inicioProcedimento").value &&
      this.dadosCadastraisForm.get("captacao.fimProcedimento").value &&
      this.dadosCadastraisForm.get("captacao.localCaptacao").value &&
      this.dadosCadastraisForm.get("captacao.profilaxia").value &&
      this.dadosCadastraisForm.get("captacao.bochechos").value &&
      this.dadosCadastraisForm.get("captacao.anestesicoTopico").value &&
      this.dadosCadastraisForm.get("captacao.anestesicoInjetavel").value &&
      this.dadosCadastraisForm.get("captacao.anestesicoVasoConstritor").value &&
      this.dadosCadastraisForm.get("captacao.clivagem").value &&
      this.dadosCadastraisForm.get("captacao.odontoseccao").value &&
      this.dadosCadastraisForm.get("captacao.remocaoRestauracoes").value &&
      this.dadosCadastraisForm.get("captacao.remocaoCaries").value &&
      this.dadosCadastraisForm.get("captacao.historiaMedicaSocial1Flag")
        .value &&
      this.dadosCadastraisForm.get("captacao.historiaMedicaSocial2Flag")
        .value &&
      this.dadosCadastraisForm.get("captacao.historiaMedicaSocial3Flag")
        .value &&
      this.dadosCadastraisForm.get("captacao.historiaMedicaSocial4Flag")
        .value &&
      this.dadosCadastraisForm.get("captacao.historiaMedicaSocial5Flag")
        .value &&
      this.dadosCadastraisForm.get("captacao.historiaMedicaSocial6Flag")
        .value &&
      this.dadosCadastraisForm.get("captacao.historiaMedicaSocial7Flag")
        .value &&
      this.dadosCadastraisForm.get("captacao.historiaMedicaSocial8Flag")
        .value &&
      this.dadosCadastraisForm.get("captacao.historiaMedicaSocial9Flag")
        .value &&
      this.dadosCadastraisForm.get("captacao.historiaMedicaSocial10Flag")
        .value &&
      this.dadosCadastraisForm.get("captacao.exameFisico1Flag").value &&
      this.dadosCadastraisForm.get("captacao.exameFisico2Flag").value &&
      this.dadosCadastraisForm.get("captacao.exameFisico3Flag").value &&
      this.dadosCadastraisForm.get("captacao.exameFisico4Flag").value &&
      this.dadosCadastraisForm.get("captacao.exameFisico5Flag").value &&
      this.dadosCadastraisForm.get("captacao.dataExamesSanguineos").value &&
      this.dadosCadastraisForm.get("captacao.hemograma").value &&
      this.dadosCadastraisForm.get("captacao.paiFlag").value &&
      this.dadosCadastraisForm.get("captacao.trypanosoma_1").value &&
      this.dadosCadastraisForm.get("captacao.trypanosoma_2").value &&
      this.dadosCadastraisForm.get("captacao.citomegalovirus_1").value &&
      this.dadosCadastraisForm.get("captacao.citomegalovirus_2").value &&
      this.dadosCadastraisForm.get("captacao.hiv_1").value &&
      this.dadosCadastraisForm.get("captacao.hiv_2").value &&
      this.dadosCadastraisForm.get("captacao.htlv").value &&
      this.dadosCadastraisForm.get("captacao.hepatiteB_1").value &&
      this.dadosCadastraisForm.get("captacao.hepatiteB_1").value &&
      this.dadosCadastraisForm.get("captacao.hepatiteB_2").value &&
      this.dadosCadastraisForm.get("captacao.hepatiteB_3").value &&
      this.dadosCadastraisForm.get("captacao.hepatiteB_4").value &&
      this.dadosCadastraisForm.get("captacao.hepatiteC_1").value &&
      this.dadosCadastraisForm.get("captacao.treponemaPallidum_1").value &&
      this.dadosCadastraisForm.get("captacao.treponemaPallidum_2").value &&
      this.dadosCadastraisForm.get("captacao.toxoplasmaGondii_1").value &&
      this.dadosCadastraisForm.get("captacao.toxoplasmaGondii_2").value &&
      this.dadosCadastraisForm.get("captacao.malaria_1").value &&
      this.dadosCadastraisForm.get("captacao.malaria_2").value &&
      this.dadosCadastraisForm.get("captacao.destinoMaterialBiologico").value &&
      this.dadosCadastraisForm.get("captacao.sARS_CoV2_Covid_19_igg").value &&
      this.dadosCadastraisForm.get("captacao.sARS_CoV2_Covid_19_igm").value &&
      this.dadosCadastraisForm.get("captacao.sARS_CoV2_Covid_pcr").value &&
      this.dadosCadastraisForm.get("captacao.sifilisvdrl").value &&
      this.dadosCadastraisForm.get("captacao.pcrqualitativocmv").value &&
      this.dadosCadastraisForm.get("captacao.pcrquantitativohepatiteb").value &&
      this.dadosCadastraisForm.get("captacao.pcrqualitativohepatitec").value &&
      this.dadosCadastraisForm.get("captacao.pcrqualitativohiv").value &&
      this.dadosCadastraisForm.get("captacao.pcrhtlv1").value &&
      this.dadosCadastraisForm.get("captacao.pcrhtlv2").value &&
      this.dadosCadastraisForm.get("captacao.pcrqualitativoepsteinbarr")
        .value &&
      this.dadosCadastraisForm.get("captacao.examesadicionais").value;

    if (verificacaoCamposColeta) {
      return true;
    } else {
      return false;
    }
  }

  onFichaValidaChange(event) {
    this.fichaValida = event;
    this.desabilitarBotoes = true;
  }

  validaFlagTermo() {
    if (
      this.flagEdCliente === "0" &&
      this.validacaoColeta() &&
      this.validacaoTecidos &&
      this.flagEdColeta !== "0"
    ) {
      this.finalizarEdColeta = true;
      return;
    }
    this.finalizarEdColeta = false;
    return;
  }
  validacaoColetaBotao() {
    // this.dadosCadastraisForm.valueChanges.subscribe(() => {
    if (
      this.flagEdCliente === "0" &&
      this.validacaoColeta() &&
      this.validacaoTecidos &&
      this.flagEdColeta !== "0"
    ) {
      this.finalizarEdColeta = true;
      return;
    }

    this.finalizarEdColeta = false;
    return;
    // });
  }

  validaTermo() {
    if (!this.maiorDeIdade) {
      if (
        this.validacaoMenorIdadeResps() &&
        this.validacaoColeta() &&
        this.validacaoTecidos
      ) {
        this.validaTermoValidoBotaoColeta();
        this.finalizarEdColeta = true;
        return;
      }
      this.finalizarEdColeta = false;
      return;
    }

    if (
      this.validacaoColeta() &&
      this.validacaoTecidos &&
      (this.dadosCadastraisForm.get("doador").valid ||
        this.dadosCadastraisForm.get("doador").disable)
    ) {
      this.validaTermoValidoBotaoColeta();
      this.finalizarEdColeta = true;
      return;
    }
    this.finalizarEdColeta = false;
    return;
  }

  validaTermoValidoBotaoColeta() {
    if (this.termoValido) {
      this.finalizarEdColeta = false;
      return;
    }
  }

  statusColeta() {
    if (this.editarWeb) {
      this.statusDaColeta = "Pendente";
    } else {
      this.statusDaColeta = "Finalizado";
    }
  }

  validarCPF(cpf: string) {
    if (this.captacao.doador) return;

    this.dadosCadastraisForm.valueChanges.subscribe(() => {
      let soma = 0;
      let resto;
      let inputCPF = this.dadosCadastraisForm.get(cpf).value;
      if (!inputCPF) {
        return;
      }
      if (inputCPF.length < 11) {
        return;
      }

      if (!this.cpfValidao0a9Sequencial(cpf)) return false;

      for (let i = 1; i <= 9; i++)
        soma = soma + parseInt(inputCPF.substring(i - 1, i)) * (11 - i);
      resto = (soma * 10) % 11;

      if (resto == 10 || resto == 11) resto = 0;
      if (resto != parseInt(inputCPF.substring(9, 10))) {
        this.dadosCadastraisForm.get(cpf).setErrors({ invalid: true });
        return false;
      }

      soma = 0;
      for (let i = 1; i <= 10; i++)
        soma = soma + parseInt(inputCPF.substring(i - 1, i)) * (12 - i);
      resto = (soma * 10) % 11;

      if (resto == 10 || resto == 11) resto = 0;
      if (resto != parseInt(inputCPF.substring(10, 11))) {
        this.dadosCadastraisForm.get(cpf).setErrors({ invalid: true });
        return false;
      }
      return true;
    });
  }

  cpfValidao0a9Sequencial(inputCPF): boolean {
    let inputCPFV = this.dadosCadastraisForm.get(inputCPF).value;

    if (inputCPFV == "00000000000") {
      this.dadosCadastraisForm.get(inputCPF).setErrors({ invalid: true });
      return false;
    }

    if (inputCPFV == "11111111111") {
      this.dadosCadastraisForm.get(inputCPF).setErrors({ invalid: true });
      return false;
    }

    if (inputCPFV == "22222222222") {
      this.dadosCadastraisForm.get(inputCPF).setErrors({ invalid: true });
      return false;
    }

    if (inputCPFV == "33333333333") {
      this.dadosCadastraisForm.get(inputCPF).setErrors({ invalid: true });
      return false;
    }

    if (inputCPFV == "44444444444") {
      this.dadosCadastraisForm.get(inputCPF).setErrors({ invalid: true });
      return false;
    }

    if (inputCPFV == "55555555555") {
      this.dadosCadastraisForm.get(inputCPF).setErrors({ invalid: true });
      return false;
    }

    if (inputCPFV == "66666666666") {
      this.dadosCadastraisForm.get(inputCPF).setErrors({ invalid: true });
      return false;
    }

    if (inputCPFV == "77777777777") {
      this.dadosCadastraisForm.get(inputCPF).setErrors({ invalid: true });
      return false;
    }

    if (inputCPFV == "88888888888") {
      this.dadosCadastraisForm.get(inputCPF).setErrors({ invalid: true });
      return false;
    }

    if (inputCPFV == "99999999999") {
      this.dadosCadastraisForm.get(inputCPF).setErrors({ invalid: true });
      return false;
    }
    return true;
  }

  validacaoDatas(data: string) {
    let dataAtual = new Date();
    this.dadosCadastraisForm.valueChanges.subscribe(() => {
      let dataNascimento = this.dadosCadastraisForm.get(data).value;
      if (!dataNascimento) {
        return;
      }
      let dataString = dataNascimento.split("/");
      let dataFormatada = new Date(
        dataString[2],
        dataString[1] - 1,
        dataString[0]
      );
      if (dataFormatada > dataAtual) {
        this.dadosCadastraisForm.get(data).setErrors({ invalid: true });
        return;
      } else {
        return;
      }
    });
  }

  datasValidacoes() {
    this.validacaoDatas("doador.dataNascimento");
    this.validacaoDatas("captacao.dataNascimentoResponsavel1");
    this.validacaoDatas("captacao.dataNascimentoResponsavel2");
    this.validacaoDatas("captacao.dataExamesSanguineos");
    this.validacaoDatas("captacao.dataColeta");
    // this.validacaoDatas("captacao.dataRecebimentoCPC");
  }

  cpfsValidacoes() {
    this.validarCPF("doador.cpf");
    this.validarCPF("captacao.cpfResponsavel1");
    this.validarCPF("captacao.cpfResponsavel2");
  }

  finalizarEdicaoCliente() {
    // this.dadosFormService.finalizarEdCliente$.pipe(take(1)).subscribe((res) => {
    //   if (res === "0") {
    //     this.dadosCadastraisForm
    //       .get("doador")
    //       .patchValue({ editarCliente: "0" });
    //     this.dadosCadastraisForm
    //       .get("doador")
    //       .patchValue({ dataHoraEditarCliente: this.dataHoraAtual() });
    //     // if(this.flagEdColeta === "0") {
    //     //   this.dadosCadastraisForm.get("editarWeb").patchValue("0");
    //     // }
    //     let doador = this.captacao.doador.doador
    //       ? this.captacao.doador.doador
    //       : this.captacao.doador;
    //     this.dadosFormService
    //       .updateFlag(doador.codigo, "cliente", this.dataHoraAtual())
    //       .subscribe((res) => {
    //         this.openSnackBar("Cliente finalizado com sucesso!", "Fechar");
    //         this.dadosCadastraisForm.get("doador").disable();
    //         this.desabilitarFormResps();
    //         this.finalizarCliente = true;
    //         this.desabilitarBotoes = true;
    //         return;
    //       });
    //     this.dadosFormService.sendClose("1");
    //   }
    //   return;
    // });
  }

  finalizarEdicaoColeta() {
    // this.coletorService.finalizarColeta$.subscribe((res) => {
    //   if (res === "0") {
    //     this.dadosCadastraisForm
    //       .get("captacao")
    //       .patchValue({ editarColeta: "0" });
    //     this.dadosCadastraisForm
    //       .get("captacao")
    //       .patchValue({ dataHoraEditarColeta: this.dataHoraAtual() });
    //     // if(this.flagEdCliente === "0"){
    //     //   this.dadosCadastraisForm.get("editarWeb").patchValue("0");
    //     // }
    //     this.dadosFormService
    //       .updateFlag(this.idCaptacao, "coleta", this.dataHoraAtual())
    //       .subscribe((res) => {
    //         this.openSnackBar("Coleta finalizado com sucesso!", "Fechar");
    //         this.desabilitarColeta();
    //         this.finalizarEdColeta = false;
    //         this.termoValido = true;
    //         this.desabilitarBotoes = true;
    //         return;
    //       });
    //   }
    //   return;
    // });
  }

  desabilitarFormResps() {
    this.dadosCadastraisForm.get("captacao.cpfResponsavel1").disable(),
      this.dadosCadastraisForm.get("captacao.rgResponsavel1").disable(),
      this.dadosCadastraisForm.get("captacao.emailResponsavel1").disable(),
      this.dadosCadastraisForm
        .get("captacao.telefoneCelularResponsavel1")
        .disable(),
      this.dadosCadastraisForm.get("captacao.cepResponsavel1").disable(),
      this.dadosCadastraisForm.get("captacao.enderecoResponsavel1").disable(),
      this.dadosCadastraisForm.get("captacao.bairroResponsavel1").disable(),
      this.dadosCadastraisForm.get("captacao.cidadeResponsavel1").disable(),
      this.dadosCadastraisForm.get("captacao.estadoResponsavel1").disable(),
      this.dadosCadastraisForm
        .get("captacao.numEnderecoResponsavel1")
        .disable(),
      this.dadosCadastraisForm.get("captacao.estadoCivilResp1").disable(),
      this.dadosCadastraisForm.get("captacao.nacionalidadeResp1").disable(),
      this.dadosCadastraisForm.get("captacao.profissaoResp1").disable(),
      this.dadosCadastraisForm.get("captacao.grauParentescoResp1").disable(),
      this.dadosCadastraisForm.get("captacao.cpfResponsavel2").disable(),
      this.dadosCadastraisForm.get("captacao.rgResponsavel2").disable(),
      this.dadosCadastraisForm.get("captacao.emailResponsavel2").disable(),
      this.dadosCadastraisForm
        .get("captacao.telefoneCelularResponsavel2")
        .disable(),
      this.dadosCadastraisForm.get("captacao.cepResponsavel2").disable(),
      this.dadosCadastraisForm.get("captacao.enderecoResponsavel2").disable(),
      this.dadosCadastraisForm.get("captacao.bairroResponsavel2").disable(),
      this.dadosCadastraisForm.get("captacao.cidadeResponsavel2").disable(),
      this.dadosCadastraisForm.get("captacao.estadoResponsavel2").disable(),
      this.dadosCadastraisForm
        .get("captacao.numEnderecoResponsavel2")
        .disable(),
      this.dadosCadastraisForm.get("captacao.estadoCivilResp2").disable(),
      this.dadosCadastraisForm.get("captacao.nacionalidadeResp2").disable(),
      this.dadosCadastraisForm.get("captacao.profissaoResp2").disable(),
      this.dadosCadastraisForm.get("captacao.grauParentescoResp2").disable(),
      this.dadosCadastraisForm.get("captacao.nomeResponsavel1").disable(),
      this.dadosCadastraisForm.get("captacao.nomeResponsavel2").disable(),
      this.dadosCadastraisForm
        .get("captacao.dataNascimentoResponsavel1")
        .disable(),
      this.dadosCadastraisForm
        .get("captacao.dataNascimentoResponsavel2")
        .disable(),
      this.dadosCadastraisForm
        .get("captacao.complementoResponsavel1")
        .disable(),
      this.dadosCadastraisForm
        .get("captacao.complementoResponsavel2")
        .disable(),
      this.dadosCadastraisForm.get("captacao.telefoneResponsavel1").disable(),
      this.dadosCadastraisForm.get("captacao.telefoneResponsavel2").disable();
  }

  desabilitarColeta() {
    this.dadosCadastraisForm.get("captacao.transportadora").disable(),
      this.dadosCadastraisForm.get("captacao.dataColeta").disable(),
      this.dadosCadastraisForm.get("captacao.inicioProcedimento").disable(),
      this.dadosCadastraisForm.get("captacao.fimProcedimento").disable(),
      this.dadosCadastraisForm.get("captacao.localCaptacao").disable(),
      this.dadosCadastraisForm.get("captacao.descricaoLocalColeta").disable(),
      this.dadosCadastraisForm.get("captacao.profilaxia").disable(),
      this.dadosCadastraisForm.get("captacao.bochechos").disable(),
      this.dadosCadastraisForm.get("captacao.anestesicoTopico").disable(),
      this.dadosCadastraisForm.get("captacao.anestesicoInjetavel").disable(),
      this.dadosCadastraisForm
        .get("captacao.anestesicoVasoConstritor")
        .disable(),
      this.dadosCadastraisForm.get("captacao.clivagem").disable(),
      this.dadosCadastraisForm.get("captacao.odontoseccao").disable(),
      this.dadosCadastraisForm.get("captacao.remocaoRestauracoes").disable(),
      this.dadosCadastraisForm.get("captacao.remocaoCaries").disable(),
      this.dadosCadastraisForm
        .get("captacao.historiaMedicaSocial1Flag")
        .disable(),
      this.dadosCadastraisForm
        .get("captacao.historiaMedicaSocial2Flag")
        .disable(),
      this.dadosCadastraisForm
        .get("captacao.historiaMedicaSocial3Flag")
        .disable(),
      this.dadosCadastraisForm
        .get("captacao.historiaMedicaSocial4Flag")
        .disable(),
      this.dadosCadastraisForm
        .get("captacao.historiaMedicaSocial5Flag")
        .disable(),
      this.dadosCadastraisForm
        .get("captacao.historiaMedicaSocial6Flag")
        .disable(),
      this.dadosCadastraisForm
        .get("captacao.historiaMedicaSocial7Flag")
        .disable(),
      this.dadosCadastraisForm
        .get("captacao.historiaMedicaSocial8Flag")
        .disable(),
      this.dadosCadastraisForm
        .get("captacao.historiaMedicaSocial9Flag")
        .disable(),
      this.dadosCadastraisForm
        .get("captacao.historiaMedicaSocial10Flag")
        .disable(),
      this.dadosCadastraisForm
        .get("captacao.historiaMedicaSocial11Flag")
        .disable(),
      this.dadosCadastraisForm
        .get("captacao.historiaMedicaSocial12Flag")
        .disable(),
      this.dadosCadastraisForm
        .get("captacao.historiaMedicaSocial13Flag")
        .disable(),
      this.dadosCadastraisForm
        .get("captacao.observacoesHistoricoSaude")
        .disable(),
      this.dadosCadastraisForm.get("captacao.exameFisico1Flag").disable(),
      this.dadosCadastraisForm.get("captacao.exameFisico2Flag").disable(),
      this.dadosCadastraisForm.get("captacao.exameFisico3Flag").disable(),
      this.dadosCadastraisForm.get("captacao.exameFisico4Flag").disable(),
      this.dadosCadastraisForm.get("captacao.exameFisico5Flag").disable(),
      this.dadosCadastraisForm.get("captacao.observacoesExameFisico").disable(),
      this.dadosCadastraisForm.get("captacao.dataExamesSanguineos").disable(),
      this.dadosCadastraisForm.get("captacao.hemograma").disable(),
      this.dadosCadastraisForm.get("captacao.paiFlag").disable(),
      this.dadosCadastraisForm.get("captacao.trypanosoma_1").disable(),
      this.dadosCadastraisForm.get("captacao.trypanosoma_2").disable(),
      this.dadosCadastraisForm.get("captacao.citomegalovirus_1").disable(),
      this.dadosCadastraisForm.get("captacao.citomegalovirus_2").disable(),
      this.dadosCadastraisForm.get("captacao.hiv_1").disable(),
      this.dadosCadastraisForm.get("captacao.hiv_2").disable(),
      this.dadosCadastraisForm.get("captacao.htlv").disable(),
      this.dadosCadastraisForm.get("captacao.hepatiteB_1").disable(),
      this.dadosCadastraisForm.get("captacao.hepatiteB_1").disable(),
      this.dadosCadastraisForm.get("captacao.hepatiteB_2").disable(),
      this.dadosCadastraisForm.get("captacao.hepatiteB_3").disable(),
      this.dadosCadastraisForm.get("captacao.hepatiteB_4").disable(),
      this.dadosCadastraisForm.get("captacao.hepatiteC_1").disable(),
      this.dadosCadastraisForm.get("captacao.treponemaPallidum_1").disable(),
      this.dadosCadastraisForm.get("captacao.treponemaPallidum_2").disable(),
      this.dadosCadastraisForm.get("captacao.toxoplasmaGondii_1").disable(),
      this.dadosCadastraisForm.get("captacao.toxoplasmaGondii_2").disable(),
      this.dadosCadastraisForm.get("captacao.malaria_1").disable(),
      this.dadosCadastraisForm.get("captacao.malaria_2").disable(),
      this.dadosCadastraisForm.get("captacao.sorologia").disable(),
      this.dadosCadastraisForm
        .get("captacao.observacoesDadosLaboratoriais")
        .disable(),
      this.dadosCadastraisForm
        .get("captacao.observacoesDadosLaboratoriais")
        .disable(),
      this.dadosCadastraisForm
        .get("captacao.destinoMaterialBiologico")
        .disable(),
      this.dadosCadastraisForm.get("captacao.doacaoPesquisa").disable(),
      this.dadosCadastraisForm.get("captacao.destinoTecidosDuros").disable(),
      this.dadosCadastraisForm.get("captacao.sARS_CoV2_Covid_19_igg").disable(),
      this.dadosCadastraisForm.get("captacao.sARS_CoV2_Covid_19_igm").disable(),
      this.dadosCadastraisForm.get("captacao.sARS_CoV2_Covid_pcr").disable(),
      this.dadosCadastraisForm.get("captacao.sifilisvdrl").disable(),
      this.dadosCadastraisForm.get("captacao.pcrqualitativocmv").disable();
    this.dadosCadastraisForm.get("captacao.pcrquantitativohepatiteb").disable(),
      this.dadosCadastraisForm
        .get("captacao.pcrqualitativohepatitec")
        .disable(),
      this.dadosCadastraisForm.get("captacao.pcrqualitativohiv").disable(),
      this.dadosCadastraisForm.get("captacao.pcrhtlv1").disable(),
      this.dadosCadastraisForm.get("captacao.pcrhtlv2").disable(),
      this.dadosCadastraisForm
        .get("captacao.pcrqualitativoepsteinbarr")
        .disable(),
      this.dadosCadastraisForm.get("captacao.examesadicionais").disable();
  }

  dataHoraAtual(): string {
    let data = new Date();
    let dataLocal = data.toLocaleDateString();
    let horaLocal = data.toLocaleTimeString();

    let dataHoraAtual = dataLocal + " " + horaLocal;
    return dataHoraAtual;
  }

  onIdadeChange(event: boolean) {
    this.maiorDeIdade = event;
  }

  onFinalizarCliente(event: boolean) {
    this.desabilitarBotoes = true;
    this.finalizarCliente = event;
    if (event) {
      this.flagEdCliente = "0";
    }
    this.validacaoColetaBotao();
  }

  onFinalizarColeta(event: boolean) {
    this.desabilitarBotoes = true;
    this.desablititarBotaoFinalizarColeta = true;
    this.termoValido = true;
  }

  teste() {
    document.querySelector(".mat-sidenav-content").scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }
}
